var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/components/image-gallery/image-gallery.tsx
import React51 from "react";
import { EGDSCard as EGDSCard5 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure4, EGDSImage as EGDSImage4 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSSheet as EGDSSheet7, EGDSSheetTransition as EGDSSheetTransition9 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
import { EGDSTransparentToolbar } from "@egds/react-core/toolbar";

// ../internal/src/components/activity-media-item/activity-media-item.tsx
import React from "react";
import { EGDSExternalButton, EGDSOverlayButton } from "@egds/react-core/button";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage, EGDSImageLink } from "@egds/react-core/images";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSVideo } from "@egds/react-core/video";
import { gql } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var __Fragment = gql`
  fragment ActivityMediaItemFragment on ActivityMediaItem {
    media {
      __typename
      ... on Image {
        description
        thumbnailClickAnalytics {
          linkName
          referrerId
        }
        imageUrl: url
      }
      ... on Video {
        description
        thumbnailClickAnalytics {
          linkName
          referrerId
        }
        thumbnail {
          value
        }
        videoUrl: url {
          value
        }
      }
    }
  }
`;
var ActivityMediaItem = props => {
  var _a;
  const {
    data,
    index,
    onClick,
    className,
    isDialog,
    isThumbnailVisible,
    dialogTriggerRef
  } = props;
  const {
    __typename
  } = data.media;
  const trackClick = useClickTracker();
  const handleClick = React.useCallback(() => {
    onClick == null ? void 0 : onClick(index);
    switch (__typename) {
      case "Image":
        if (data.media.thumbnailClickAnalytics) {
          trackClick(data.media.thumbnailClickAnalytics.referrerId, data.media.thumbnailClickAnalytics.linkName);
        }
        break;
      case "Video":
        if (data.media.thumbnailClickAnalytics) {
          trackClick(data.media.thumbnailClickAnalytics.referrerId, data.media.thumbnailClickAnalytics.linkName);
        }
    }
  }, [onClick, index]);
  switch (__typename) {
    case "Video":
      if (isThumbnailVisible) {
        return /* @__PURE__ */React.createElement(EGDSFigure, {
          ratio: EGDSFigureAspectRatioType.R16_9,
          className
        }, /* @__PURE__ */React.createElement(EGDSImage, {
          placeholderImage: true,
          src: (_a = data.media.thumbnail) == null ? void 0 : _a.value,
          alt: data.media.description
        }), onClick && /* @__PURE__ */React.createElement(EGDSImageLink, null, /* @__PURE__ */React.createElement("button", {
          ref: dialogTriggerRef,
          onClick: handleClick != null ? handleClick : void 0,
          type: "button"
        })), /* @__PURE__ */React.createElement(EGDSLayoutPosition, {
          position: {
            top: "center",
            left: "center"
          },
          type: "absolute"
        }, /* @__PURE__ */React.createElement(EGDSOverlayButton, null, /* @__PURE__ */React.createElement(EGDSIcon, {
          name: "play_arrow"
        }))));
      }
      return /* @__PURE__ */React.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R16_9,
        className
      }, /* @__PURE__ */React.createElement(EGDSVideo, {
        src: data.media.videoUrl.value,
        isDialog,
        alt: data.media.description
      }), onClick != null && /* @__PURE__ */React.createElement(EGDSImageLink, null, /* @__PURE__ */React.createElement(EGDSExternalButton, {
        domRef: dialogTriggerRef,
        onClick: handleClick != null ? handleClick : void 0,
        type: "button",
        "aria-labelledby": data.media.description,
        "aria-label": data.media.description
      })));
    case "Image":
      return /* @__PURE__ */React.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R16_9,
        className
      }, /* @__PURE__ */React.createElement(EGDSImage, {
        placeholderImage: true,
        src: data.media.imageUrl,
        alt: onClick ? "" : data.media.description
      }), onClick != null && /* @__PURE__ */React.createElement(EGDSImageLink, null, /* @__PURE__ */React.createElement("button", {
        ref: dialogTriggerRef,
        onClick: handleClick != null ? handleClick : void 0,
        type: "button",
        "aria-label": data.media.description
      })));
    default:
      return null;
  }
};
ActivityMediaItem.displayName = "ActivityMediaItem";
ActivityMediaItem.fragment = __Fragment;

// ../internal/src/components/egds-carousel/egds-carousel.tsx
import React21 from "react";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { gql as gql22 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-button/egds-button.tsx
import React16 from "react";
import { EGDSOverlayButton as EGDSOverlayButton2, EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { gql as gql17 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-button/egds-button-action.ts
import { gql as gql16 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-heading.tsx
import React2 from "react";
import { EGDSHeading } from "@egds/react-core/text";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/heading-map.ts
var headingTagMapper = {
  ["H1" /* H1 */]: "h1",
  ["H2" /* H2 */]: "h2",
  ["H3" /* H3 */]: "h3",
  ["H4" /* H4 */]: "h4",
  ["H5" /* H5 */]: "h5",
  ["H6" /* H6 */]: "h6",
  ["H7" /* H7 */]: "h6",
  ["H8" /* H8 */]: "h6"
};

// ../internal/src/components/egds-text/egds-heading.tsx
var fragment = gql2`
  fragment EGDSHeadingFragment on EGDSHeading {
    text
    headingType
    accessibility
  }
`;
var ActivitiesEGDSHeading = ({
  className,
  align,
  size,
  tag,
  data,
  tabIndex
}) => {
  const {
    headingType,
    text,
    accessibility
  } = data;
  const headingTag = tag != null ? tag : headingType ? headingTagMapper[headingType] : void 0;
  return /* @__PURE__ */React2.createElement(React2.Fragment, null, /* @__PURE__ */React2.createElement(EGDSHeading, {
    className,
    align,
    tag: tag != null ? tag : headingTag,
    size,
    tabIndex,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React2.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
ActivitiesEGDSHeading.fragment = fragment;
ActivitiesEGDSHeading.displayName = "ActivitiesEGDSHeading";

// ../internal/src/components/egds-text/egds-paragraph.tsx
import React3 from "react";
import { EGDSParagraph } from "@egds/react-core/text";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/paragraph-style-size-map.ts
var paragraphStyleSizeMap = {
  ["P1" /* P1 */]: 1,
  ["P2" /* P2 */]: 2,
  ["P3" /* P3 */]: 3
};

// ../internal/src/components/egds-text/egds-paragraph.tsx
var fragment2 = gql3`
  fragment EGDSParagraphFragment on EGDSParagraph {
    text
    style
  }
`;
var ActivitiesEGDSParagraph = ({
  className,
  data
}) => {
  const {
    text,
    style
  } = data;
  return /* @__PURE__ */React3.createElement(EGDSParagraph, {
    className,
    size: paragraphStyleSizeMap[style]
  }, text);
};
ActivitiesEGDSParagraph.fragment = fragment2;
ActivitiesEGDSParagraph.displayName = "ActivitiesEGDSParagraph";

// ../internal/src/components/egds-text/egds-standard-link.tsx
import React7 from "react";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText } from "@egds/react-core/text";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React4 from "react";
import { EGDSIcon as EGDSIcon2, EGDSIconSize } from "@egds/react-core/icons";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";
var __EGDSIconFragment = gql4`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    theme
    title
    withBackground
  }
`;
var ActivitiesEGDSIcon = ({
  className,
  data
}) => {
  var _a, _b;
  return /* @__PURE__ */React4.createElement(EGDSIcon2, {
    className,
    description: data.description,
    id: Math.random().toString(),
    name: data.id,
    size: data.size ? EGDSIconSize[data.size] : void 0,
    title: (_a = data.title) != null ? _a : void 0,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    shadow: Boolean(data.withBackground)
  });
};
ActivitiesEGDSIcon.displayName = "ActivitiesEGDSIcon";
ActivitiesEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-mark.tsx
import React5 from "react";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
var __EGDSMarkFragment = gql5`
  fragment EGDSMarkFragment on Mark {
    description
    id
    markSize: size
    url {
      ... on HttpURI {
        __typename
        relativePath
        value
      }
    }
  }
`;
var ActivitiesEGDSMark = ({
  className,
  data
}) => {
  var _a;
  return /* @__PURE__ */React5.createElement(EGDSMark, {
    className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? EGDSMarkSize[data.markSize] : void 0,
    url: (_a = data.url) == null ? void 0 : _a.value
  });
};
ActivitiesEGDSMark.displayName = "ActivitiesEGDSMark";
ActivitiesEGDSMark.fragment = __EGDSMarkFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React6 from "react";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
var __EGDSGraphicFragment = gql6`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }

    ... on Mark {
      ...EGDSMarkFragment
    }
  }

  ${ActivitiesEGDSIcon.fragment}
  ${ActivitiesEGDSMark.fragment}
`;
var EGDSGraphic = ({
  className,
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React6.createElement(ActivitiesEGDSIcon, {
        className,
        data
      });
    case "Mark":
      return /* @__PURE__ */React6.createElement(ActivitiesEGDSMark, {
        className,
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = {
  ["SMALL" /* SMALL */]: "small",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["LARGE" /* LARGE */]: "large"
};
var UILinkTargetMap = {
  ["EXTERNAL" /* EXTERNAL */]: "_blank",
  ["INTERNAL" /* INTERNAL */]: "_self"
};

// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql7`
  fragment EGDSStandardLinkFragment on EGDSStandardLink {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
        ... on HttpURI {
          relativePath
        }
      }
      target
      useRelativePath
    }
    disabled
    standardLinkIcon: icon {
      ...EGDSIconFragment
    }
    iconPosition
    size
    text
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var IconPlacement = ({
  icon,
  iconPosition,
  iconPositionToMatch
}) => {
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React7.createElement(ActivitiesEGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = ({
  className,
  inline,
  align,
  data: {
    action: {
      analytics,
      resource,
      target,
      accessibility,
      useRelativePath
    },
    disabled,
    iconPosition,
    standardLinkIcon,
    size,
    text
  }
}) => {
  const clickTracker = useClickTracker2();
  const onClick = React7.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  const getPath = React7.useCallback(() => {
    switch (resource.__typename) {
      case "HttpURI":
        return useRelativePath ? resource.relativePath : resource.value;
      default:
        return resource.value;
    }
  }, [resource, useRelativePath]);
  return /* @__PURE__ */React7.createElement(EGDSLink, {
    className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline,
    disabled,
    align
  }, /* @__PURE__ */React7.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React7.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React7.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React7.createElement(EGDSText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";

// ../internal/src/components/egds-text/egds-text.tsx
import React15 from "react";
import { gql as gql15 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React8 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";
var fragment4 = gql8`
  fragment EGDSGraphicTextFragment on EGDSGraphicText {
    graphic {
      ...EGDSGraphicFragment
    }
    text
  }

  ${EGDSGraphic.fragment}
`;
var graphicMargin = {
  inlineend: "one"
};
var textMargin = {
  inlineend: "one"
};
var EGDSGraphicText = ({
  className,
  size,
  data
}) => {
  const {
    graphic,
    text
  } = data;
  return /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
    className
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React8.createElement(EGDSSpacing, {
    margin: graphicMargin
  }, /* @__PURE__ */React8.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React8.createElement(EGDSSpacing, {
    margin: textMargin
  }, /* @__PURE__ */React8.createElement(EGDSText2, {
    size
  }, text))));
};
EGDSGraphicText.fragment = fragment4;
EGDSGraphicText.displayName = "EGDSGraphicText";

// ../internal/src/components/egds-text/egds-icon-text.tsx
import React9 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { gql as gql9 } from "@shared-ui/apollo-client-wrapper";
var fragment5 = gql9`
  fragment EGDSIconTextFragment on EGDSIconText {
    icon {
      ...EGDSIconFragment
    }
    text
  }

  ${ActivitiesEGDSIcon.fragment}
`;
var iconMargin = {
  inlineend: "one"
};
var textMargin2 = {
  inlineend: "one"
};
var EGDSIconText = ({
  className,
  size,
  data
}) => {
  const {
    icon,
    text
  } = data;
  return /* @__PURE__ */React9.createElement(EGDSLayoutFlex2, {
    className
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React9.createElement(EGDSSpacing2, {
    margin: iconMargin
  }, /* @__PURE__ */React9.createElement(ActivitiesEGDSIcon, {
    data: icon
  }))), /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React9.createElement(EGDSSpacing2, {
    margin: textMargin2
  }, /* @__PURE__ */React9.createElement(EGDSText3, {
    size
  }, text))));
};
EGDSIconText.fragment = fragment5;
EGDSIconText.displayName = "EGDSIconText";

// ../internal/src/components/egds-text/egds-inline-link.tsx
import React10 from "react";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var fragment6 = gql10`
  fragment EGDSInlineLinkFragment on EGDSInlineLink {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
      }
      target
    }
    disabled
    size
    text
  }
`;
var EGDSInlineLink = ({
  className,
  data: {
    action: {
      analytics,
      resource,
      target,
      accessibility
    },
    disabled,
    size,
    text
  }
}) => {
  const clickTracker = useClickTracker3();
  const onClick = React10.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React10.createElement(EGDSLink2, {
    className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    disabled,
    inline: true
  }, /* @__PURE__ */React10.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap[target]
  }, text, accessibility && /* @__PURE__ */React10.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSInlineLink.fragment = fragment6;
EGDSInlineLink.displayName = "EGDSInlineLink";

// ../internal/src/components/egds-text/egds-plain-text.tsx
import React11 from "react";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";
var fragment7 = gql11`
  fragment EGDSPlainTextFragment on EGDSPlainText {
    text
  }
`;
var EGDSPlainText = ({
  className,
  inline,
  align,
  size,
  theme,
  data
}) => {
  const {
    text
  } = data;
  return /* @__PURE__ */React11.createElement(EGDSText4, {
    whiteSpace: "pre-line",
    className,
    align,
    size,
    inline,
    theme
  }, text);
};
EGDSPlainText.fragment = fragment7;
EGDSPlainText.displayName = "EGDSPlainText";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React14 from "react";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React13 from "react";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React12 from "react";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = {
  ["EMPHASIS" /* EMPHASIS */]: "emphasis",
  ["NEGATIVE" /* NEGATIVE */]: "negative",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["PRIMARY" /* PRIMARY */]: "emphasis",
  ["SECONDARY" /* SECONDARY */]: "default",
  ["LOYALTY" /* LOYALTY */]: "loyalty",
  ["INVERSE" /* INVERSE */]: "inverse"
};
var EGDSTextThemeMapper = {
  ["NEGATIVE" /* NEGATIVE */]: "negative",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["EMPHASIS" /* EMPHASIS */]: "emphasis",
  ["LOYALTY" /* LOYALTY */]: "loyalty",
  ["DEFAULT" /* DEFAULT */]: "default"
};

// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = {
  ["BOLD" /* BOLD */]: "bold",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["REGULAR" /* REGULAR */]: "regular"
};

// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment8 = gql12`
  fragment EGDSStylizedTextFragment on EGDSStylizedText {
    text
    theme
    weight
    accessibility
    decorative
    textSize: size
  }
`;
var EGDSStylizedText = ({
  className,
  inline,
  align,
  size,
  data
}) => {
  const {
    text,
    theme,
    weight,
    accessibility,
    decorative
  } = data;
  const themeProps = theme ? textThemeMapper[theme] : void 0;
  const weightProps = weight ? textWeightMapper[weight] : void 0;
  const RenderText = () => /* @__PURE__ */React12.createElement(React12.Fragment, null, /* @__PURE__ */React12.createElement(EGDSText5, {
    className,
    align,
    inline,
    size,
    theme: themeProps,
    weight: weightProps,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
  switch (decorative) {
    case "LINE_THROUGH" /* LINE_THROUGH */:
      return /* @__PURE__ */React12.createElement("s", null, /* @__PURE__ */React12.createElement(RenderText, null));
    default:
      return /* @__PURE__ */React12.createElement(RenderText, null);
  }
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment9 = gql13`
  fragment EGDSSpannableTextContentFragment on EGDSText {
    ...EGDSStylizedTextFragment
    ...EGDSGraphicTextFragment
    ...EGDSPlainTextFragment
  }

  ${EGDSStylizedText.fragment}
  ${EGDSGraphicText.fragment}
  ${EGDSPlainText.fragment}
`;
var EGDSSpannableTextContent = ({
  className,
  size,
  align,
  theme,
  data
}) => {
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React13.createElement(EGDSStylizedText, {
        className,
        data,
        size,
        inline: true
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React13.createElement(EGDSGraphicText, {
        className,
        data,
        size
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React13.createElement(EGDSPlainText, {
        className,
        data,
        size,
        align,
        inline: true,
        theme
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";

// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment10 = gql14`
  fragment EGDSSpannableTextFragment on EGDSSpannableText {
    text
    contents {
      ...EGDSSpannableTextContentFragment
    }
    inlineContent {
      ...EGDSSpannableTextContentFragment
    }
  }

  ${EGDSSpannableTextContent.fragment}
`;
var EGDSSpannableText = props => {
  var _b, _c, _d;
  const _a = props,
    {
      align,
      headingSize,
      data,
      theme
    } = _a,
    styleProps = __objRest(_a, ["align", "headingSize", "data", "theme"]);
  if (((_b = data == null ? void 0 : data.contents) == null ? void 0 : _b.length) === 0 && !((_c = data == null ? void 0 : data.inlineContent) == null ? void 0 : _c.length)) {
    return /* @__PURE__ */React14.createElement(EGDSText6, __spreadProps(__spreadValues({}, styleProps), {
      inline: true,
      align,
      theme
    }), data.text);
  }
  if ((_d = data == null ? void 0 : data.inlineContent) == null ? void 0 : _d.length) {
    return /* @__PURE__ */React14.createElement(React14.Fragment, null, data.inlineContent.map((item, index) => /* @__PURE__ */React14.createElement(React14.Fragment, null, /* @__PURE__ */React14.createElement(EGDSSpannableTextContent, __spreadProps(__spreadValues({
      align,
      data: item
    }, styleProps), {
      key: `spannable-item-${index}`,
      theme
    })), " ")));
  }
  return /* @__PURE__ */React14.createElement(React14.Fragment, null, data.contents.map((item, index) => /* @__PURE__ */React14.createElement(React14.Fragment, {
    key: `spannable-item-${index}`
  }, /* @__PURE__ */React14.createElement(EGDSSpannableTextContent, __spreadProps(__spreadValues({
    data: item
  }, styleProps), {
    headingSize,
    theme
  })), " ")));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";

// ../internal/src/components/egds-text/egds-text.tsx
var fragment11 = gql15`
  fragment EGDSTextFragment on EGDSText {
    ...EGDSHeadingFragment
    ...EGDSPlainTextFragment
    ...EGDSStylizedTextFragment
    ...EGDSIconTextFragment
    ...EGDSGraphicTextFragment
    ...EGDSParagraphFragment
    ...EGDSStandardLinkFragment
    ...EGDSInlineLinkFragment
    ...EGDSSpannableTextFragment
  }

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSPlainText.fragment}
  ${EGDSStylizedText.fragment}
  ${EGDSIconText.fragment}
  ${EGDSGraphicText.fragment}
  ${ActivitiesEGDSParagraph.fragment}
  ${EGDSStandardLink.fragment}
  ${EGDSInlineLink.fragment}
  ${EGDSSpannableText.fragment}
`;
var ActivitiesEGDSText = ({
  className,
  headingAlign,
  headingSize,
  headingTag,
  textAlign,
  textSize,
  align,
  inline,
  tabIndex,
  theme,
  data
}) => {
  switch (data == null ? void 0 : data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React15.createElement(ActivitiesEGDSHeading, {
        className,
        align: headingAlign,
        size: headingSize,
        tag: headingTag,
        data,
        tabIndex
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React15.createElement(EGDSPlainText, {
        className,
        align: textAlign,
        size: textSize,
        data,
        inline,
        theme
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React15.createElement(EGDSStylizedText, {
        className,
        align: textAlign,
        size: textSize,
        data,
        inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React15.createElement(EGDSGraphicText, {
        className,
        size: textSize,
        data
      });
    case "EGDSIconText":
      return /* @__PURE__ */React15.createElement(EGDSIconText, {
        className,
        size: textSize,
        data
      });
    case "EGDSParagraph":
      return /* @__PURE__ */React15.createElement(ActivitiesEGDSParagraph, {
        className,
        data
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React15.createElement(EGDSStandardLink, {
        className,
        data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React15.createElement(EGDSInlineLink, {
        className,
        data
      });
    case "EGDSSpannableText":
      return /* @__PURE__ */React15.createElement(EGDSSpannableText, {
        className,
        size: textSize,
        headingSize,
        data,
        align,
        theme
      });
    default:
      return null;
  }
};
ActivitiesEGDSText.fragment = fragment11;
ActivitiesEGDSText.displayName = "ActivitiesEGDSText";

// ../internal/src/components/egds-button/egds-button-action.ts
var __EGDSButtonActionFragment = gql16`
  fragment EGDSButtonActionFragment on UIAction {
    analytics {
      linkName
      referrerId
    }

    ... on ActivityOpenOffersModalAction {
      activityId
      dateRange {
        startDate {
          day
          month
          year
        }
        endDate {
          day
          month
          year
        }
      }
      dismissButtonAccessibility
      dismissButtonAnalytics {
        linkName
        referrerId
      }
      selectedOffers {
        offerProductNaturalKey
      }
      heading {
        ...EGDSHeadingFragment
      }
      subHeading {
        ...EGDSPlainTextFragment
      }
      travelers {
        ...ActivityTravelerDetailsFragment
      }
    }

    ... on ActivityAddOfferToTripAction {
      callbackMessages {
        failure
        success
      }
      offerNaturalKey {
        offerProductNaturalKey
      }
    }

    ... on ActivityRemoveOffersFromTripAction {
      callbackMessages {
        failure
        success
      }
      offerNaturalKeys {
        offerProductNaturalKey
      }
    }

    ... on ActivityUpdateOfferInTripAction {
      callbackMessages {
        failure
        success
      }
      newOfferNaturalKey {
        offerProductNaturalKey
      }
      oldOfferNaturalKey {
        offerProductNaturalKey
      }
    }
  }
  fragment ActivityTravelerDetailsFragment on ActivityTravelerDetails {
    age
    count
  }

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSPlainText.fragment}
`;

// ../internal/src/components/egds-button/egds-button.tsx
var _Fragment = gql17`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    accessibility
    disabled
    action {
      ...EGDSButtonActionFragment
    }
    icon {
      description
      id
      title
    }
  }

  ${__EGDSButtonActionFragment}
`;
var ActivitiesEGDSButton = ({
  analytics,
  className,
  domRef,
  href,
  isFullWidth,
  onClickHandler,
  size,
  data
}) => {
  var _a;
  const {
    __typename,
    accessibility,
    action,
    primary,
    disabled,
    icon
  } = data;
  const clickTracker = useClickTracker4();
  const analyticsButton = action ? {
    description: action.analytics.linkName,
    id: action.analytics.referrerId,
    callback: (referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }
  } : void 0;
  const handleOnClick = React16.useCallback(() => {
    onClickHandler == null ? void 0 : onClickHandler();
  }, [onClickHandler]);
  if (!primary) {
    return null;
  }
  const buttonProps = {
    analytics: analytics || analyticsButton,
    "aria-label": accessibility != null ? accessibility : void 0,
    className,
    disabled,
    href,
    isFullWidth,
    onClick: handleOnClick,
    size,
    domRef
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React16.createElement(EGDSPrimaryButton, __spreadValues({}, buttonProps), primary);
    case "UISecondaryButton":
      return /* @__PURE__ */React16.createElement(EGDSSecondaryButton, __spreadValues({}, buttonProps), primary);
    case "UITertiaryButton":
      return /* @__PURE__ */React16.createElement(EGDSTertiaryButton, __spreadValues({}, buttonProps), primary);
    case "EGDSOverlayButton":
      return /* @__PURE__ */React16.createElement(EGDSOverlayButton2, __spreadValues({}, buttonProps), icon && /* @__PURE__ */React16.createElement(EGDSIcon3, {
        name: (_a = icon == null ? void 0 : icon.id) != null ? _a : ""
      }), primary);
    default:
      return null;
  }
};
ActivitiesEGDSButton.fragment = _Fragment;
ActivitiesEGDSButton.displayName = "ActivitiesEGDSButton";

// ../internal/src/components/egds-carousel/egds-card-carousel-item.tsx
import React19 from "react";
import { gql as gql20 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-card/egds-card.tsx
import React18 from "react";
import { gql as gql19 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-card/egds-standard-messaging-card.tsx
import React17 from "react";
import { Link } from "react-router-dom-v5-compat";
import { EGDSCard, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSSubheading } from "@egds/react-core/text";
import { gql as gql18 } from "@shared-ui/apollo-client-wrapper";
import { IntersectionTracker, useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
var __Fragment2 = gql18`
  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {
    graphic {
      ...EGDSGraphicFragment
    }
    heading
    impressionTracking {
      linkName
      referrerId
    }
    links {
      action {
        resource {
          value
          ... on HttpURI {
            relativePath
          }
        }
        useRelativePath
      }
      text
    }
    message
  }
  ${EGDSGraphic.fragment}
`;
var EGDSStandardMessagingCard = ({
  data,
  border,
  className,
  graphicSpacing
}) => {
  var _a, _b;
  const {
    graphic,
    heading,
    message,
    links,
    impressionTracking
  } = data;
  const graphicSpacingProps = graphicSpacing != null ? graphicSpacing : {
    margin: {
      blockend: "twelve"
    }
  };
  const getUrl = function (link) {
    const {
      action: {
        resource,
        useRelativePath
      }
    } = link;
    switch (resource.__typename) {
      case "HttpURI":
        return useRelativePath ? resource.relativePath : resource.value;
      default:
        return resource.value;
    }
  };
  const clickTracker = useClickTracker5();
  const trackAnalytics = () => {
    if (impressionTracking) {
      clickTracker(impressionTracking.referrerId, impressionTracking.linkName);
    }
  };
  return /* @__PURE__ */React17.createElement(IntersectionTracker, {
    trackOnce: true,
    referrerId: (impressionTracking == null ? void 0 : impressionTracking.referrerId) ? `${impressionTracking == null ? void 0 : impressionTracking.referrerId}.carousel.view.impression` : "",
    linkName: (_a = impressionTracking == null ? void 0 : impressionTracking.linkName) != null ? _a : "",
    intersectionOptions: {
      threshold: 1
    },
    cloneElement: true
  }, /* @__PURE__ */React17.createElement(EGDSCard, {
    padded: true,
    className,
    border
  }, graphic && /* @__PURE__ */React17.createElement(EGDSSpacing3, __spreadValues({}, graphicSpacingProps), /* @__PURE__ */React17.createElement(EGDSGraphic, {
    data: graphic
  })), heading && /* @__PURE__ */React17.createElement(EGDSHeading2, {
    size: 7
  }, heading), /* @__PURE__ */React17.createElement(EGDSSubheading, null, message), (links == null ? void 0 : links.length) && /* @__PURE__ */React17.createElement(EGDSCardLink, null, /* @__PURE__ */React17.createElement(Link, {
    onClick: trackAnalytics,
    to: getUrl(links[0])
  }, (_b = links[0]) == null ? void 0 : _b.text))));
};
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
EGDSStandardMessagingCard.fragment = __Fragment2;

// ../internal/src/components/egds-card/egds-card.tsx
var __Fragment3 = gql19`
  fragment EGDSCardFragment on EGDSCard {
    ... on EGDSStandardMessagingCard {
      ...EGDSStandardMessagingCardFragment
    }
  }
  ${EGDSStandardMessagingCard.fragment}
`;
var ActivitiesEGDSCard = ({
  data,
  border,
  className,
  graphicSpacing
}) => {
  switch (data.__typename) {
    case "EGDSStandardMessagingCard":
      return /* @__PURE__ */React18.createElement(EGDSStandardMessagingCard, {
        data,
        className,
        border,
        graphicSpacing
      });
    default:
      return null;
  }
};
ActivitiesEGDSCard.displayName = "ActivitiesEGDSCard";
ActivitiesEGDSCard.fragment = __Fragment3;

// ../internal/src/components/egds-carousel/egds-card-carousel-item.tsx
var __Fragment4 = gql20`
  fragment EGDSCardCarouselItemFragment on EGDSCardCarouselItem {
    card {
      ...EGDSCardFragment
    }
    id
  }

  ${ActivitiesEGDSCard.fragment}
`;
var EGDSCardCarouselItem = ({
  data,
  border,
  className,
  graphicSpacing
}) => {
  const {
    card,
    id
  } = data;
  return /* @__PURE__ */React19.createElement(ActivitiesEGDSCard, {
    data: card,
    className,
    id: id != null ? id : "",
    border,
    graphicSpacing
  });
};
EGDSCardCarouselItem.displayName = "EGDSCardCarouselItem";
EGDSCardCarouselItem.fragment = __Fragment4;

// ../internal/src/components/egds-carousel/egds-media-carousel-item.tsx
import React20 from "react";
import { gql as gql21 } from "@shared-ui/apollo-client-wrapper";
var __Fragment5 = gql21`
  fragment EGDSMediaCarouselItemFragment on EGDSMediaCarouselItem {
    id
    media {
      ...ActivityMediaItemFragment
    }
  }
  ${ActivityMediaItem.fragment}
`;
var EGDSMediaCarouselItem = ({
  data,
  className,
  index
}) => {
  const {
    media
  } = data;
  switch (media.__typename) {
    case "ActivityMediaItem":
      return /* @__PURE__ */React20.createElement(ActivityMediaItem, {
        data: media,
        index,
        className,
        isDialog: true
      });
    default:
      return null;
  }
};
EGDSMediaCarouselItem.displayName = "EGDSMediaCarouselItem";
EGDSMediaCarouselItem.fragment = __Fragment5;

// ../internal/src/components/egds-carousel/egds-carousel.tsx
var __Fragment6 = gql22`
  fragment EGDSCarouselFragment on EGDSCarousel {
    carouselId
    items {
      ...EGDSMediaCarouselItemFragment
      ...EGDSCardCarouselItemFragment
    }
    nextButton {
      ...EGDSButtonFragment
    }
    previousButton {
      ...EGDSButtonFragment
    }
  }

  ${EGDSMediaCarouselItem.fragment}
  ${EGDSCardCarouselItem.fragment}
  ${ActivitiesEGDSButton.fragment}
`;
var ActivitiesEGDSCarousel = ({
  cardGraphicSpacing,
  carouselName,
  data,
  className,
  peek,
  itemsVisible,
  currentIndex,
  setCurrentState,
  stretchToFill,
  fullSheetVisible,
  itemBorder,
  pageBy
}) => {
  var _a, _b;
  const defaultItemsVisible = {
    sm: 1,
    md: 1,
    lg: 1,
    xl: 1
  };
  const buttonTextMemo = React21.useMemo(() => {
    var _a2, _b2, _c, _d;
    return {
      nextButton: (_b2 = (_a2 = data.nextButton) == null ? void 0 : _a2.accessibility) != null ? _b2 : "",
      prevButton: (_d = (_c = data.previousButton) == null ? void 0 : _c.accessibility) != null ? _d : ""
    };
  }, [data]);
  const trackClick = useClickTracker6();
  const analytics = (_b = (_a = data.nextButton) == null ? void 0 : _a.action) == null ? void 0 : _b.analytics;
  const onIndexChange = index => {
    if (index === 0 || index === -1) {
      return;
    }
    setCurrentState == null ? void 0 : setCurrentState(index);
    if (analytics) {
      trackClick(analytics.referrerId, analytics.linkName);
    }
  };
  const CarouselContent = data.items.map((item, index) => {
    switch (item.__typename) {
      case "EGDSMediaCarouselItem":
        return /* @__PURE__ */React21.createElement(EGDSMediaCarouselItem, {
          key: `egds-media-carousel-item-${index}`,
          data: item,
          index
        });
      case "EGDSCardCarouselItem":
        return /* @__PURE__ */React21.createElement(EGDSCardCarouselItem, {
          key: `egds-card-carousel-item-${index}`,
          data: item,
          border: itemBorder,
          graphicSpacing: cardGraphicSpacing
        });
      default:
        return null;
    }
  });
  return /* @__PURE__ */React21.createElement(EGDSCarousel, {
    navigationIconId: {
      next: "next-button-media-gallery",
      prev: "prev-button-media-gallery"
    },
    fullSheetVisible: fullSheetVisible != null ? fullSheetVisible : false,
    className,
    carouselName: carouselName != null ? carouselName : void 0,
    buttonText: buttonTextMemo,
    itemsMaxHeight: true,
    itemsVisible: itemsVisible != null ? itemsVisible : defaultItemsVisible,
    pageBy: pageBy != null ? pageBy : 1,
    peek: peek != null ? peek : false,
    startIndex: currentIndex,
    onIndexChange,
    stretchToFill: stretchToFill != null ? stretchToFill : false,
    pagingInset: true
  }, CarouselContent);
};
ActivitiesEGDSCarousel.displayName = "ActivitiesEGDSCarousel";
ActivitiesEGDSCarousel.fragment = __Fragment6;

// src/components/image-gallery/image-gallery.tsx
import { gql as gql59, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { ViewLarge, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";

// src/components/image-gallery/__private/image-gallery-utils.tsx
var numberOfColumns = numberOfImagesToShow2 => {
  switch (numberOfImagesToShow2) {
    case 5:
      return 4;
    case 3:
      return 3;
    default:
      return 1;
  }
};
var numberOfImagesToShow = (maxImages, featuredMedia) => {
  var _a;
  const imageSlice = featuredMedia == null ? void 0 : featuredMedia.slice(0, maxImages);
  if (imageSlice && imageSlice.length % 2 === 0) {
    imageSlice.pop();
  }
  return (_a = imageSlice == null ? void 0 : imageSlice.length) != null ? _a : 0;
};

// src/components/image-gallery/__private/__fragments/activity-thumbnail-media-gallery-dialog.tsx
import React50 from "react";
import { MinMax as MinMax2, Repeat as Repeat2 } from "@egds/react-core/layout-grid";

// ../internal/src/components/activity-dialog/activity-date-range-picker-dialog.tsx
import React26 from "react";
import { EGDSDatePicker, EGDSDatePickerRenderType, EGDSDatePickerTriggeredSelector } from "@egds/react-core/date-picker";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { gql as gql33 } from "@shared-ui/apollo-client-wrapper";
import { useDialog } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";

// ../internal/src/__fragments/common/date-fragment.ts
import { gql as gql23 } from "@shared-ui/apollo-client-wrapper";
var __DateFragment = gql23`
  fragment DateFragment on Date {
    day
    month
    year
  }
`;

// ../internal/src/__fragments/common/client-side-analytics.ts
import { gql as gql24 } from "@shared-ui/apollo-client-wrapper";
var clientSideAnalyticsFragment = gql24`
  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {
    linkName
    referrerId
    uisPrimeMessages {
      messageContent
      schemaName
    }
  }
`;

// ../internal/src/__fragments/common/car-rental-location.ts
import { gql as gql25 } from "@shared-ui/apollo-client-wrapper";
var __CarRentalLocation = gql25`
  fragment CarRentalLocationFragment on CarRentalLocation {
    airportCode
    coordinates {
      latitude
      longitude
    }
    isExactLocationSearch
    regionId
    searchTerm
  }
`;

// ../internal/src/__fragments/common/date-time.ts
import { gql as gql26 } from "@shared-ui/apollo-client-wrapper";
var __DateTime = gql26`
  fragment DateTimeFragment on DateTime {
    day
    month
    year
    hour
    minute
    second
  }
`;

// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-toolbar.tsx
import React22 from "react";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { gql as gql27 } from "@shared-ui/apollo-client-wrapper";
var __Fragment7 = gql27`
  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {
    closeText
    title
  }
`;
var EGDSDialogToolbar = ({
  data,
  toolbarType,
  toolbarAction
}) => {
  var _a;
  return /* @__PURE__ */React22.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: toolbarAction,
      navType: toolbarType,
      navIconLabel: (_a = data.closeText) != null ? _a : void 0
    },
    toolbarTitle: data.title
  });
};
EGDSDialogToolbar.fragment = __Fragment7;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";

// ../internal/src/components/activity-dialog/__private/__fragments/egds-travelers-step-input.tsx
import React23 from "react";
import { EGDSStepInput } from "@egds/react-core/step-input";
import { gql as gql28 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
var __Fragment8 = gql28`
  fragment EGDSTravelerStepInputFragment on EGDSStepInput {
    ... on EGDSTravelerStepInput {
      egdsElementId
      decreaseAnalytics {
        linkName
        referrerId
      }
      increaseAnalytics {
        linkName
        referrerId
      }
    }
    decreaseText
    increaseText
    label
    key
    max
    min
    step
    subLabel
    value
  }
`;
var EGDSTravelersStepInput = ({
  data,
  onChange,
  countIndex
}) => {
  const {
    decreaseText,
    increaseText,
    label,
    max,
    min,
    step,
    subLabel,
    value,
    key
  } = data;
  const [countValue, setCountValue] = React23.useState(value);
  const clickTracker = useClickTracker7();
  const handleChange = event => {
    const stepValue = parseInt(event.target.value, 10);
    onChange(stepValue, key, countIndex);
    if (data.__typename === "EGDSTravelerStepInput") {
      if (stepValue > countValue) {
        clickTracker(data.increaseAnalytics.referrerId, data.increaseAnalytics.linkName);
      } else {
        clickTracker(data.decreaseAnalytics.referrerId, data.decreaseAnalytics.linkName);
      }
    }
    setCountValue(stepValue);
  };
  const travelerId = React23.useMemo(() => Math.random().toString(), []);
  return /* @__PURE__ */React23.createElement(EGDSStepInput, {
    label,
    incrementText: increaseText != null ? increaseText : "",
    decrementText: decreaseText != null ? decreaseText : "",
    incrementId: `${travelerId}-increase`,
    decrementId: `${travelerId}-decrease`,
    min: min != null ? min : 0,
    max: max != null ? max : 0,
    step,
    onChange: handleChange,
    value: countValue,
    description: subLabel != null ? subLabel : "",
    id: travelerId
  });
};
EGDSTravelersStepInput.displayName = "EGDSTravelersStepInput";
EGDSTravelersStepInput.fragment = __Fragment8;

// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer.tsx
import React24 from "react";
import { EGDSDialogFooter } from "@egds/react-core/dialog";
import { gql as gql30 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer-button.ts
import { gql as gql29 } from "@shared-ui/apollo-client-wrapper";
var __EGDSDialogFooterButtonFragment = gql29`
  fragment EGDSDialogFooterButtonFragment on EGDSButton {
    primary
    accessibility
    disabled
  }
`;
var getButton = (data, closeDialog) => {
  var _a, _b, _c;
  switch (data.__typename) {
    case "UITertiaryButton":
      {
        return {
          text: (_a = data.primary) != null ? _a : "",
          type: "tertiary",
          onClick: closeDialog
        };
      }
    case "UIPrimaryButton":
      return {
        text: (_b = data.primary) != null ? _b : "",
        type: "primary",
        onClick: closeDialog
      };
    default:
      return {
        text: (_c = data.primary) != null ? _c : "",
        type: "primary",
        onClick: closeDialog
      };
  }
};

// ../internal/src/components/activity-dialog/__private/__fragments/egds-dialog-footer.tsx
var __EGDSDialogFooterFragment = gql30`
  fragment EGDSDialogFooterFragment on EGDSDialogFooter {
    ... on EGDSInlineDialogFooter {
      buttons {
        ...EGDSDialogFooterButtonFragment
      }
    }
  }

  ${__EGDSDialogFooterButtonFragment}
`;
var ActivitiesEGDSDialogFooter = ({
  data,
  dialogActionMap,
  closeDialog
}) => {
  var _a, _b, _c;
  switch (data.__typename) {
    case "EGDSInlineDialogFooter":
      {
        const {
          buttons
        } = data;
        const buttonMap = buttons.map((button, index) => {
          if (dialogActionMap && dialogActionMap.length > 1) {
            return __spreadValues(__spreadValues({}, getButton(button, closeDialog)), dialogActionMap[index]);
          }
          return __spreadValues({}, getButton(button, closeDialog));
        });
        return /* @__PURE__ */React24.createElement(EGDSDialogFooter, {
          buttonOne: (_a = buttonMap[0]) != null ? _a : void 0,
          buttonTwo: (_b = buttonMap[1]) != null ? _b : void 0,
          buttonThree: (_c = buttonMap[2]) != null ? _c : void 0
        });
      }
    default:
      return null;
  }
};
ActivitiesEGDSDialogFooter.displayName = "ActivitiesEGDSDialogFooter";
ActivitiesEGDSDialogFooter.fragment = __EGDSDialogFooterFragment;

// ../internal/src/components/activity-dialog/__private/__fragments/egds-date-picker-content.ts
import { gql as gql31 } from "@shared-ui/apollo-client-wrapper";
var __EGDSDatePickerContentFragment = gql31`
  fragment EGDSDatePickerContentFragment on EGDSDatePickerContent {
    accessibility
    dateKey
    text
    theme
  }
`;
var getDatePickerContent = data => {
  const {
    accessibility,
    dateKey,
    text,
    theme
  } = data;
  return {
    [dateKey]: {
      text: text != null ? text : "",
      ariaLabel: accessibility != null ? accessibility : void 0,
      className: theme != null ? theme : void 0
    }
  };
};

// ../internal/src/components/activity-dialog/__private/activity-date-range-picker-dialog-helper.ts
import { DayName } from "@egds/react-core/date-picker";
var convertFromMiliSecondsToDays = miliseconds => Math.ceil(miliseconds / 1e3 / 60 / 60 / 24);
var convertToDateObject = ({
  year,
  month,
  day
}) => new Date(year, month - 1, day);
var EGDSDayNameMap = {
  ["SUN" /* SUN */]: DayName.SUN,
  ["MON" /* MON */]: DayName.MON,
  ["TUE" /* TUE */]: DayName.TUE,
  ["WED" /* WED */]: DayName.WED,
  ["THU" /* THU */]: DayName.THU,
  ["FRI" /* FRI */]: DayName.FRI,
  ["SAT" /* SAT */]: DayName.SAT
};

// ../internal/src/components/activity-dialog/activity-dialog-trigger.tsx
import React25 from "react";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSCard as EGDSCard2, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSFakeInput } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { gql as gql32 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
var __Fragment9 = gql32`
  fragment ActivityDialogTriggerFragment on ActivityDialogTrigger {
    accessibility
    analytics {
      linkName
      referrerId
    }

    ... on ActivityButtonDialogTrigger {
      button {
        ...EGDSButtonFragment
      }
    }

    ... on ActivityGraphicDialogTrigger {
      graphic {
        ...EGDSGraphicFragment
      }
    }

    ... on ActivityLinkDialogTrigger {
      linkGraphic: graphic {
        ...EGDSGraphicFragment
      }
      label
    }

    ... on ActivityFakeInputDialogTrigger {
      icon {
        id
      }
      label
      value
    }

    ... on ActivityMapDialogTrigger {
      staticMapImage {
        accessibility
        url
      }
      mapTriggerLabel: label
    }
  }

  ${EGDSGraphic.fragment}
  ${ActivitiesEGDSButton.fragment}
`;
var ActivityDialogTrigger = ({
  className,
  data,
  domRef,
  linkIconPosition = "TRAILING" /* TRAILING */,
  openDialog,
  autoFocus
}) => {
  var _a, _b, _c;
  const {
    accessibility,
    analytics
  } = data;
  const clickTracker = useClickTracker8();
  const analyticsDialogTrigger = {
    description: analytics.linkName,
    id: analytics.referrerId,
    callback: React25.useCallback((referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  const trackAnalytics = React25.useCallback(() => {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [analytics, clickTracker]);
  switch (data.__typename) {
    case "ActivityButtonDialogTrigger":
      return /* @__PURE__ */React25.createElement(ActivitiesEGDSButton, {
        analytics: analyticsDialogTrigger,
        size: EGDSButtonSize.MEDIUM,
        onClickHandler: openDialog,
        domRef,
        data: data.button
      });
    case "ActivityGraphicDialogTrigger":
      return /* @__PURE__ */React25.createElement(EGDSMoreInfoTrigger, {
        className,
        analytics: analyticsDialogTrigger,
        onClick: openDialog,
        size: "small"
      }, /* @__PURE__ */React25.createElement("button", {
        ref: domRef,
        type: "button"
      }, /* @__PURE__ */React25.createElement(EGDSGraphic, {
        data: data.graphic
      }), /* @__PURE__ */React25.createElement("span", {
        className: "is-visually-hidden"
      }, accessibility)));
    case "ActivityFakeInputDialogTrigger":
      return /* @__PURE__ */React25.createElement("div", {
        className
      }, /* @__PURE__ */React25.createElement(EGDSFakeInput, {
        domRef,
        label: data.label,
        value: (_a = data.value) != null ? _a : "",
        icon: (_b = data.icon) == null ? void 0 : _b.id,
        onChange: openDialog,
        onClick: openDialog,
        analytics: analyticsDialogTrigger,
        autoFocus
      }));
    case "ActivityLinkDialogTrigger":
      return /* @__PURE__ */React25.createElement(EGDSLink3, {
        className,
        onClick: openDialog,
        onClickCapture: trackAnalytics,
        size: "medium"
      }, /* @__PURE__ */React25.createElement("button", {
        ref: domRef,
        type: "button"
      }, data.linkGraphic && linkIconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React25.createElement(EGDSGraphic, {
        data: data.linkGraphic
      }), data.label, data.linkGraphic && linkIconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React25.createElement(EGDSGraphic, {
        data: data.linkGraphic
      }), /* @__PURE__ */React25.createElement("span", {
        className: "is-visually-hidden",
        "aria-hidden": data.label === accessibility
      }, accessibility)));
    case "ActivityMapDialogTrigger":
      return /* @__PURE__ */React25.createElement(EGDSLayoutFlex3, {
        className
      }, /* @__PURE__ */React25.createElement(EGDSLink3, {
        onClickCapture: trackAnalytics
      }, /* @__PURE__ */React25.createElement("button", {
        ref: domRef,
        type: "button",
        onClick: openDialog,
        "aria-labelledby": accessibility
      }, /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem3, {
        minWidth: "full_width"
      }, /* @__PURE__ */React25.createElement(EGDSCard2, {
        border: true
      }, ((_c = data.staticMapImage) == null ? void 0 : _c.url) && /* @__PURE__ */React25.createElement(EGDSFigure2, {
        ratio: EGDSFigureAspectRatioType2.R21_9
      }, /* @__PURE__ */React25.createElement(EGDSImage2, {
        src: data.staticMapImage.url,
        alt: data.staticMapImage.accessibility || ""
      })), data.mapTriggerLabel && /* @__PURE__ */React25.createElement(EGDSCardContentSection, null, /* @__PURE__ */React25.createElement(EGDSLayoutFlex3, {
        justifyContent: "center"
      }, data.mapTriggerLabel)))))));
    default:
      return null;
  }
};
ActivityDialogTrigger.displayName = "ActivityDialogTrigger";
ActivityDialogTrigger.fragment = __Fragment9;

// ../internal/src/components/activity-dialog/activity-date-range-picker-dialog.tsx
var __Fragment10 = gql33`
  fragment ActivityDateRangePickerDialogFragment on ActivityDateRangePickerDialog {
    dateRangePicker {
      buttonText
      dateFormat
      firstDayOfWeek
      footerText
      sameDaySelectionAllowed
      selectedEndDate {
        ...DateFragment
      }
      selectedStartDate {
        ...DateFragment
      }
      validDaysLowerBoundInclusive {
        ...DateFragment
      }
      validDaysUpperBoundInclusive {
        ...DateFragment
      }
      datePickerContent {
        ...EGDSDatePickerContentFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
  }

  ${__EGDSDatePickerContentFragment}
  ${__DateFragment}
  ${ActivityDialogTrigger.fragment}
`;
var ActivityDateRangePickerDialog = ({
  className,
  onSubmitHandler,
  data,
  isNestedDialog
}) => {
  const {
    formatDateString
  } = useLocalization();
  const dialogKey = React26.useMemo(() => Math.random().toString(36).slice(2, 5), []);
  const nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog(`activity-date-range-picker-dialog-${dialogKey}`, nestedDialogKey);
  const {
    dateRangePicker: {
      buttonText,
      firstDayOfWeek,
      footerText,
      sameDaySelectionAllowed,
      selectedEndDate,
      selectedStartDate,
      validDaysLowerBoundInclusive,
      validDaysUpperBoundInclusive,
      dateFormat,
      datePickerContent
    },
    trigger
  } = data;
  const today = /* @__PURE__ */new Date();
  const tomorrow = /* @__PURE__ */new Date();
  tomorrow.setDate(today.getDate() + 1);
  const defaultDaysBookableInAdvance = 500;
  const dateRangePickerTrigger = React26.createRef();
  const [startDate, setStartDate] = React26.useState(formatDateString(today, {
    raw: dateFormat
  }));
  const [endDate, setEndDate] = React26.useState(formatDateString(tomorrow, {
    raw: dateFormat
  }));
  const [validStartDate, setValidStartDate] = React26.useState(formatDateString(today, {
    raw: dateFormat
  }));
  const [daysBookableInAdvance, setDaysBookableInAdvance] = React26.useState(defaultDaysBookableInAdvance);
  const [datePickerContentMap, setDatePickerContentMap] = React26.useState(void 0);
  React26.useEffect(() => {
    const dateFormatOptions = {
      raw: dateFormat
    };
    if (selectedStartDate) {
      setStartDate(formatDateString(convertToDateObject(selectedStartDate), dateFormatOptions));
    }
    if (selectedEndDate) {
      setEndDate(formatDateString(convertToDateObject(selectedEndDate), dateFormatOptions));
    }
    if (validDaysLowerBoundInclusive) {
      setValidStartDate(formatDateString(convertToDateObject(validDaysLowerBoundInclusive), dateFormatOptions));
    }
    if (validDaysUpperBoundInclusive) {
      const difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - (/* @__PURE__ */new Date()).getTime();
      setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
    }
    if (datePickerContent == null ? void 0 : datePickerContent.length) {
      const newDatePickerContent = datePickerContent.reduce((contentMap, content) => __spreadValues(__spreadValues({}, contentMap), getDatePickerContent(content)), {});
      setDatePickerContentMap(newDatePickerContent);
    }
  }, [formatDateString, selectedEndDate, selectedStartDate, validDaysLowerBoundInclusive, validDaysUpperBoundInclusive, dateFormat, datePickerContent]);
  const onDismissCB = React26.useCallback(() => {
    dialogActions.closeDialog();
    if (dateRangePickerTrigger.current && typeof dateRangePickerTrigger.current.focus === "function") {
      dateRangePickerTrigger.current.focus();
    }
  }, [dialogActions, dateRangePickerTrigger]);
  const onSubmitCB = React26.useCallback((start, end) => {
    const newEndDate = end || new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
    const startDateFormatted = formatDateString(start, {
      raw: dateFormat
    });
    const endDateFormatted = formatDateString(newEndDate, {
      raw: dateFormat
    });
    setStartDate(startDateFormatted);
    setEndDate(endDateFormatted);
    onSubmitHandler(startDateFormatted, endDateFormatted);
    onDismissCB();
  }, [dateFormat, formatDateString, onDismissCB, onSubmitHandler]);
  const dateFieldProps = {
    showDatePicker: true,
    useCustomTrigger: true
  };
  const datePickerProps = {
    buttonText,
    dateFieldProps,
    datePickerContent: datePickerContentMap,
    daysBookableInAdvance,
    doubleMonths: true,
    endDate,
    firstDayOfWeek: EGDSDayNameMap[firstDayOfWeek],
    footerText: footerText != null ? footerText : void 0,
    onDismissCB,
    onSubmitCB,
    renderType: EGDSDatePickerRenderType.DIALOG,
    singleDateSelect: sameDaySelectionAllowed,
    startDate,
    triggeredSelector: EGDSDatePickerTriggeredSelector.START,
    validStartDate
  };
  return /* @__PURE__ */React26.createElement(React26.Fragment, null, /* @__PURE__ */React26.createElement(ActivityDialogTrigger, {
    className,
    domRef: dateRangePickerTrigger,
    linkIconPosition: "LEADING" /* LEADING */,
    openDialog: dialogActions.openDialog,
    data: trigger
  }), /* @__PURE__ */React26.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React26.createElement(DialogComponent, null, /* @__PURE__ */React26.createElement(EGDSDatePicker, __spreadValues({}, datePickerProps)))));
};
ActivityDateRangePickerDialog.displayName = "ActivityDateRangePickerDialog";
ActivityDateRangePickerDialog.fragment = __Fragment10;

// ../internal/src/components/activity-dialog/activity-disclaimer-dialog.tsx
import React27 from "react";
import { EGDSDialog, EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { gql as gql35 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";

// ../internal/src/components/actions/activity-click-action.ts
import { gql as gql34 } from "@shared-ui/apollo-client-wrapper";
var __ActivityClickActionsFragment = gql34`
  fragment ActivityClickActionsFragment on ActivityClickAction {
    accessibilityText
    clientSideAnalytics {
      linkName
      referrerId
    }
    ... on ActivityLinkClickAction {
      linkTagUrl
      opensInNewTab
    }

    ... on ActivityRefClickAction {
      sectionRef
    }

    ... on ActivitySelectionClickAction {
      selectionList {
        id
        value
      }
    }
    ... on ActivityPaginationInfoAction {
      pagination {
        size
        startingIndex
      }
    }
  }
`;
var getClickAction = (data, clickTracker, closeDialog) => {
  switch (data.__typename) {
    case "ActivityLinkClickAction":
      {
        const linkDialog = () => {
          const {
            clientSideAnalytics,
            linkTagUrl,
            opensInNewTab
          } = data;
          clickTracker(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
          if (linkTagUrl) {
            window.open(linkTagUrl, opensInNewTab ? "_blank" : "_self");
          }
        };
        return {
          onClick: linkDialog
        };
      }
    case "ActivityRefClickAction":
      return {
        href: `#${data.sectionRef}`
      };
    case "ActivityCloseDialogClickAction":
      return {
        onClick: closeDialog
      };
    case "ActivitySelectionClickAction":
      {
        const tabSelection = () => {
          const {
            clientSideAnalytics,
            selectionList
          } = data;
          clickTracker(clientSideAnalytics == null ? void 0 : clientSideAnalytics.referrerId, clientSideAnalytics == null ? void 0 : clientSideAnalytics.linkName);
          if (selectionList) {
            return selectionList;
          }
        };
        return {
          selectedTabAction: tabSelection()
        };
      }
    case "ActivityPaginationInfoAction":
      {
        const {
          clientSideAnalytics,
          pagination
        } = data;
        clickTracker(clientSideAnalytics == null ? void 0 : clientSideAnalytics.referrerId, clientSideAnalytics == null ? void 0 : clientSideAnalytics.linkName);
        return {
          paginatedIndex: pagination
        };
      }
    default:
      return null;
  }
};

// ../internal/src/components/activity-dialog/activity-disclaimer-dialog.tsx
var __Fragment11 = gql35`
  fragment ActivityDisclaimerDialogFragment on ActivityDisclaimerDialog {
    contents {
      ...EGDSTextFragment
    }
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      footer {
        ...EGDSDialogFooterFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
    dialogActions {
      ...ActivityClickActionsFragment
    }
  }

  ${__ActivityClickActionsFragment}
  ${ActivityDialogTrigger.fragment}

  ${__EGDSDialogFooterFragment}
  ${ActivitiesEGDSText.fragment}
`;
var ActivityDisclaimerDialog = ({
  className,
  data,
  dialogIdSuffix,
  linkIconPosition
}) => {
  const {
    contents,
    dialog,
    trigger,
    dialogActions
  } = data;
  const clickTracker = useClickTracker9();
  const randomDialogKey = React27.useMemo(() => Math.random().toString(36).substr(2, 5), []);
  const dialogKey = dialogIdSuffix != null ? dialogIdSuffix : randomDialogKey;
  const [isDialogOpen, dialogComponentActions, DialogComponent] = useDialog2(`activity-disclaimer-dialog-${dialogKey}`, "nestedActivityDisclaimerDialog");
  const dialogActionMap = dialogActions == null ? void 0 : dialogActions.map(dialogAction => getClickAction(dialogAction, clickTracker, dialogComponentActions.closeDialog));
  const activityLinkDialogTrigger = React27.createRef();
  const closeDialog = React27.useCallback(() => {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    if (activityLinkDialogTrigger.current && typeof activityLinkDialogTrigger.current.focus === "function") {
      activityLinkDialogTrigger.current.focus();
    }
    dialogComponentActions.closeDialog();
  }, [dialogComponentActions, clickTracker, dialog.closeAnalytics]);
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(ActivityDialogTrigger, {
    className,
    domRef: activityLinkDialogTrigger,
    openDialog: dialogComponentActions.openDialog,
    data: trigger,
    linkIconPosition
  }), /* @__PURE__ */React27.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React27.createElement(DialogComponent, null, /* @__PURE__ */React27.createElement(EGDSDialog, {
    dialogShow: isDialogOpen,
    ariaLabel: trigger.accessibility,
    returnFocusOnClose: true
  }, /* @__PURE__ */React27.createElement(EGDSDialogContent, null, contents.map((content, index) => /* @__PURE__ */React27.createElement(ActivitiesEGDSText, {
    key: `disclaimer-dialog-contents-${index}`,
    data: content
  })), /* @__PURE__ */React27.createElement(ActivitiesEGDSDialogFooter, {
    data: dialog.footer,
    dialogActionMap,
    closeDialog
  }))))));
};
ActivityDisclaimerDialog.displayName = "ActivityDisclaimerDialog";
ActivityDisclaimerDialog.fragment = __Fragment11;

// ../internal/src/components/activity-dialog/activity-traveler-selection-dialog.tsx
import React28 from "react";
import { EGDSButtonSize as EGDSButtonSize2, EGDSFloatingFullWidthButton } from "@egds/react-core/button";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { gql as gql36 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var __Fragment12 = gql36`
  fragment ActivityTravelerSelectorDialogFragment on ActivityTravelerSelectorDialog {
    heading {
      ...EGDSHeadingFragment
    }
    doneButton {
      primary
      action {
        analytics {
          linkName
          referrerId
        }
      }
    }
    ticketsStepInput {
      ...EGDSTravelerStepInputFragment
    }
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
    errorMessageForSelectedTickets {
      ...EGDSGraphicTextFragment
    }
  }

  ${ActivityDialogTrigger.fragment}

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSTravelersStepInput.fragment}
  ${EGDSDialogToolbar.fragment}
  ${EGDSGraphicText.fragment}
`;
var headingMargin = {
  blockend: "two"
};
var ActivityTravelerSelectorDialog = ({
  className,
  doneClickHandler,
  data,
  isNestedDialog,
  autoFocus
}) => {
  const clickTracker = useClickTracker10();
  const {
    heading,
    dialog,
    doneButton,
    ticketsStepInput,
    trigger,
    errorMessageForSelectedTickets
  } = data;
  const [ticket, setTicketValue] = React28.useState();
  const randomDialogKey = React28.useMemo(() => Math.random().toString(36).slice(2, 5), []);
  const nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog3(`activity-traveler-selection-dialog-${randomDialogKey}`, nestedDialogKey);
  const triggerRef = React28.useRef(null);
  const [isDoneButtonDisabled, setIsDoneButtonDisabled] = React28.useState(false);
  const intialTickets = React28.useMemo(() => {
    const travelerTicket = [];
    ticketsStepInput.forEach(step => {
      var _a;
      const travlerData = {
        code: (_a = step.key) != null ? _a : "",
        count: step.value
      };
      travelerTicket.push(travlerData);
    });
    setTicketValue(travelerTicket);
    return travelerTicket;
  }, [ticketsStepInput]);
  const onTravelerSelector = React28.useCallback((value, key, countIndex) => {
    intialTickets[countIndex] = {
      code: key != null ? key : "",
      count: value
    };
    setTicketValue(intialTickets);
    const atLeastOneTicketCount = intialTickets.find(t => t.count > 0);
    setIsDoneButtonDisabled(!atLeastOneTicketCount);
  }, [intialTickets]);
  const closeToolbarAction = React28.useCallback(() => {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  }, [dialog.closeAnalytics, clickTracker]);
  const onClick = React28.useCallback(() => {
    var _a;
    doneClickHandler(ticket != null ? ticket : []);
    if ((_a = doneButton.action) == null ? void 0 : _a.analytics) {
      clickTracker(doneButton.action.analytics.referrerId, doneButton.action.analytics.linkName);
    }
    dialogActions.closeDialog();
  }, [doneClickHandler, ticket]);
  const openDialog = React28.useCallback(() => {
    const atLeastOneTicketCount = ticketsStepInput.find(t => t.value > 0);
    setIsDoneButtonDisabled(!atLeastOneTicketCount);
    dialogActions.openDialog();
  }, []);
  const renderTravelerSelectionDialog = viewportType => /* @__PURE__ */React28.createElement(EGDSSheet, {
    type: viewportType,
    isVisible: true,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React28.createElement(EGDSDialogToolbar, {
    toolbarType: "close",
    toolbarAction: closeToolbarAction,
    data: dialog.toolbar
  }), /* @__PURE__ */React28.createElement(EGDSSheetContent, null, heading && /* @__PURE__ */React28.createElement(EGDSSpacing4, {
    margin: headingMargin
  }, /* @__PURE__ */React28.createElement(ActivitiesEGDSHeading, {
    size: 6,
    data: heading
  })), ticketsStepInput.map((count, index) => /* @__PURE__ */React28.createElement(EGDSTravelersStepInput, {
    key: index,
    countIndex: index,
    onChange: onTravelerSelector,
    data: count
  })), /* @__PURE__ */React28.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "three"
    }
  }, isDoneButtonDisabled && errorMessageForSelectedTickets ? /* @__PURE__ */React28.createElement(EGDSGraphicText, {
    data: errorMessageForSelectedTickets
  }) : /* @__PURE__ */React28.createElement("div", null, "\xA0")), /* @__PURE__ */React28.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React28.createElement(EGDSFloatingFullWidthButton, {
    size: EGDSButtonSize2.LARGE,
    onClick,
    disabled: isDoneButtonDisabled
  }, doneButton.primary))));
  return /* @__PURE__ */React28.createElement(React28.Fragment, null, /* @__PURE__ */React28.createElement(ActivityDialogTrigger, {
    className,
    openDialog,
    data: trigger,
    domRef: triggerRef,
    autoFocus
  }), /* @__PURE__ */React28.createElement(EGDSSheetTransition3, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React28.createElement(DialogComponent, null, /* @__PURE__ */React28.createElement(Viewport, null, /* @__PURE__ */React28.createElement(ViewSmall, null, renderTravelerSelectionDialog("full" /* FULL_SCREEN */)), /* @__PURE__ */React28.createElement(ViewMedium, null, renderTravelerSelectionDialog("centered" /* CENTERED */))))));
};
ActivityTravelerSelectorDialog.displayName = "ActivityTravelerSelectorDialog";
ActivityTravelerSelectorDialog.fragment = __Fragment12;

// ../internal/src/components/activity-dialog/activity-radio-group-dialog.tsx
import React32 from "react";
import { EGDSButtonSize as EGDSButtonSize3, EGDSFloatingFullWidthButton as EGDSFloatingFullWidthButton2 } from "@egds/react-core/button";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { gql as gql40 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";

// ../internal/src/components/egds-radio-group/egds-basic-radio-group.tsx
import React31 from "react";
import { EGDSRadioButtonGroup } from "@egds/react-core/radio-button";
import { gql as gql39 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-radio-group/egds-radio-button.tsx
import React30 from "react";
import { gql as gql38 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-radio-group/egds-basic-radio-button.tsx
import React29 from "react";
import { EGDSRadioButton } from "@egds/react-core/radio-button";
import { gql as gql37 } from "@shared-ui/apollo-client-wrapper";
var __Fragment13 = gql37`
  fragment EGDSBasicRadioButtonFragment on EGDSBasicRadioButton {
    description
    disabled
    label
    labelSuffix
    value
  }
`;
var EGDSBasicRadioButton = ({
  data,
  groupName
}) => {
  const {
    description,
    disabled,
    label,
    labelSuffix,
    value
  } = data;
  return /* @__PURE__ */React29.createElement(EGDSRadioButton, {
    key: `${groupName}-${value}`,
    disabled,
    id: value,
    value,
    description: description != null ? description : void 0,
    label,
    labelSuffix: labelSuffix != null ? labelSuffix : void 0
  });
};
EGDSBasicRadioButton.displayName = "EGDSBasicRadioButton";
EGDSBasicRadioButton.fragment = __Fragment13;

// ../internal/src/components/egds-radio-group/egds-radio-button.tsx
var _Fragment2 = gql38`
  fragment EGDSRadioButtonFragment on EGDSRadioButton {
    ... on EGDSBasicRadioButton {
      ...EGDSBasicRadioButtonFragment
    }
  }

  ${EGDSBasicRadioButton.fragment}
`;
var ActivitiesEGDSRadioButton = ({
  data,
  groupName
}) => {
  switch (data.__typename) {
    case "EGDSBasicRadioButton":
      return /* @__PURE__ */React30.createElement(EGDSBasicRadioButton, {
        groupName,
        data
      });
    default:
      return null;
  }
};
ActivitiesEGDSRadioButton.displayName = "ActivitiesEGDSRadioButton";
ActivitiesEGDSRadioButton.fragment = _Fragment2;

// ../internal/src/components/egds-radio-group/egds-basic-radio-group.tsx
var __Fragment14 = gql39`
  fragment EGDSBasicRadioGroupFragment on EGDSBasicRadioGroup {
    groupName
    selected
    options {
      ...EGDSRadioButtonFragment
    }
  }

  ${ActivitiesEGDSRadioButton.fragment}
`;
var EGDSBasicRadioGroup = ({
  data,
  onChange
}) => {
  const {
    groupName,
    selected,
    options
  } = data;
  return /* @__PURE__ */React31.createElement(EGDSRadioButtonGroup, {
    group: groupName,
    onChange,
    selected: selected != null ? selected : void 0,
    defaultChecked: true
  }, options.map((option, index) => /* @__PURE__ */React31.createElement(ActivitiesEGDSRadioButton, {
    key: `egds-radio-group-${index}`,
    data: option,
    groupName
  })));
};
EGDSBasicRadioGroup.displayName = "EGDSBasicRadioGroup";
EGDSBasicRadioGroup.fragment = __Fragment14;

// ../internal/src/components/activity-dialog/activity-radio-group-dialog.tsx
var __Fragment15 = gql40`
  fragment ActivityRadioGroupDialogFragment on ActivityRadioGroupDialog {
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    doneButton {
      primary
      action {
        analytics {
          linkName
          referrerId
        }
      }
    }
    heading {
      ...EGDSHeadingFragment
    }
    radioGroup {
      ...EGDSBasicRadioGroupFragment
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
  }

  ${ActivityDialogTrigger.fragment}

  ${ActivitiesEGDSHeading.fragment}
  ${EGDSBasicRadioGroup.fragment}
  ${EGDSDialogToolbar.fragment}
`;
var headingMargin2 = {
  blockend: "two"
};
var ActivityRadioGroupDialog = ({
  className,
  doneClickHandler,
  data,
  isNestedDialog
}) => {
  var _a;
  const {
    heading,
    dialog,
    doneButton: {
      action,
      primary
    },
    radioGroup,
    trigger
  } = data;
  const clickTracker = useClickTracker11();
  const dialogKey = React32.useMemo(() => Math.random().toString(36).slice(2, 5), []);
  const nestedDialogKey = isNestedDialog ? "pwaDialogNested" : void 0;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog4(`activity-radio-dialog-${dialogKey}`, nestedDialogKey);
  const [selectedValue, setSelectedValue] = React32.useState((_a = radioGroup.selected) != null ? _a : "");
  const triggerRef = React32.useRef(null);
  const handleOnChange = event => {
    setSelectedValue(event.target.value);
  };
  const handleToolbarAction = React32.useCallback(() => {
    if (dialog.closeAnalytics) {
      clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  }, [dialogActions, dialog.closeAnalytics, clickTracker]);
  const handleDoneOnClick = React32.useCallback(() => {
    if (action == null ? void 0 : action.analytics) {
      clickTracker(action.analytics.referrerId, action.analytics.linkName);
    }
    doneClickHandler(radioGroup.groupName, selectedValue);
    dialogActions.closeDialog();
  }, [doneClickHandler, clickTracker, action == null ? void 0 : action.analytics, dialogActions, radioGroup.groupName, selectedValue]);
  return /* @__PURE__ */React32.createElement(React32.Fragment, null, /* @__PURE__ */React32.createElement(ActivityDialogTrigger, {
    className,
    openDialog: dialogActions.openDialog,
    data: trigger,
    domRef: triggerRef
  }), /* @__PURE__ */React32.createElement(EGDSSheetTransition4, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React32.createElement(DialogComponent, null, /* @__PURE__ */React32.createElement(EGDSSheet2, {
    type: "centered",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React32.createElement(EGDSDialogToolbar, {
    toolbarType: "close",
    toolbarAction: handleToolbarAction,
    data: dialog.toolbar
  }), /* @__PURE__ */React32.createElement(EGDSSheetContent2, null, heading && /* @__PURE__ */React32.createElement(EGDSSpacing5, {
    margin: headingMargin2
  }, /* @__PURE__ */React32.createElement(ActivitiesEGDSHeading, {
    size: 6,
    data: heading
  })), /* @__PURE__ */React32.createElement(EGDSBasicRadioGroup, {
    onChange: handleOnChange,
    data: radioGroup
  }), /* @__PURE__ */React32.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React32.createElement(EGDSFloatingFullWidthButton2, {
    size: EGDSButtonSize3.LARGE,
    onClick: handleDoneOnClick
  }, primary)))))));
};
ActivityRadioGroupDialog.displayName = "ActivityRadioGroupDialog";
ActivityRadioGroupDialog.fragment = __Fragment15;

// ../internal/src/components/activity-dialog/activity-review-comments-dialog.tsx
import React42 from "react";
import { EGDSDialogContent as EGDSDialogContent2 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex6 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet3, EGDSSheetTransition as EGDSSheetTransition5 } from "@egds/react-core/sheet";
import { gql as gql49 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";

// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-dialog-content.tsx
import React40, { useRef } from "react";
import { EGDSCard as EGDSCard3 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex5 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing9, EGDSSpacingHr } from "@egds/react-core/spacing";
import { gql as gql48 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/utils/utils.ts
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom-v5-compat";
var randomKey = Math.random().toString(36).substr(2, 5);
function useQueryParams() {
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  return searchParams;
}
function useDeleteParam() {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(key => {
    const params = new URLSearchParams(location.search);
    params.delete(key);
    navigate(`${location.pathname}?${params}`, {
      replace: true
    });
  }, [navigate, location]);
}

// ../internal/src/components/activity-reviews-comment/activity-reviews-comment.tsx
import React36 from "react";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4, EGDSText as EGDSText7 } from "@egds/react-core/text";
import { gql as gql44 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-expando/egds-expando-peek.tsx
import React33 from "react";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { gql as gql41 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
var fragment12 = gql41`
  fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {
    expandAnalytics {
      linkName
      referrerId
    }
    expandedLabel
    expandedAccessibilityText
    collapsedAccessibilityText
    collapseAnalytics {
      linkName
      referrerId
    }
    collapsedLabel
    expanded
  }
`;
var ActivitiesEGDSExpandoPeek = ({
  lines,
  items,
  className,
  data,
  children
}) => {
  var _a, _b, _c, _d;
  const {
    expanded,
    expandAnalytics,
    expandedLabel,
    collapseAnalytics,
    collapsedLabel,
    expandedAccessibilityText,
    collapsedAccessibilityText
  } = data;
  const clickTracker = useClickTracker12();
  const [isVisible, setIsVisible] = React33.useState(expanded);
  const expandoExpandAnalytics = {
    id: (_a = expandAnalytics == null ? void 0 : expandAnalytics.referrerId) != null ? _a : "",
    description: (_b = expandAnalytics == null ? void 0 : expandAnalytics.linkName) != null ? _b : "",
    callback: React33.useCallback((referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  const expandoCollapseAnalytics = {
    id: (_c = collapseAnalytics == null ? void 0 : collapseAnalytics.referrerId) != null ? _c : "",
    description: (_d = collapseAnalytics == null ? void 0 : collapseAnalytics.linkName) != null ? _d : "",
    callback: React33.useCallback((referrerId, linkName) => {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  const handleClick = React33.useCallback(() => {
    setIsVisible(!isVisible);
  }, [isVisible]);
  return /* @__PURE__ */React33.createElement(EGDSExpandoPeek, {
    expandLabel: collapsedLabel,
    collapseLabel: expandedLabel,
    analytics: isVisible ? expandoCollapseAnalytics : expandoExpandAnalytics,
    className,
    lines,
    items,
    isVisible,
    handleClick,
    expandA11yLabel: collapsedAccessibilityText != null ? collapsedAccessibilityText : collapsedLabel,
    collapseA11yLabel: expandedAccessibilityText != null ? expandedAccessibilityText : expandedLabel
  }, children);
};
ActivitiesEGDSExpandoPeek.fragment = fragment12;
ActivitiesEGDSExpandoPeek.displayName = "ActivitiesEGDSExpandoPeek";

// ../internal/src/components/egds-expando/egds-expando-list-item.tsx
import React34 from "react";
import { EGDSExpandoListItem } from "@egds/react-core/expando";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
import { gql as gql42 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
var fragment13 = gql42`
  fragment EGDSExpandoListItemFragment on EGDSExpandoListItem {
    collapseAnalytics {
      linkName
      referrerId
    }
    collapsedLabel
    expandAnalytics {
      linkName
      referrerId
    }
    expandedLabel
    expanded
  }
`;
var ActivitiesEGDSExpandoListItem = ({
  children,
  className,
  data,
  titleSize,
  titleTag,
  isIndented
}) => {
  const {
    expandAnalytics,
    expandedLabel,
    collapseAnalytics,
    collapsedLabel,
    expanded
  } = data;
  const clickTracker = useClickTracker13();
  const [isVisible, setIsVisible] = React34.useState(expanded);
  const [label, setLabel] = React34.useState(expanded ? expandedLabel : collapsedLabel);
  let analytics;
  if (collapseAnalytics && expandAnalytics) {
    analytics = {
      id: isVisible ? collapseAnalytics.referrerId : expandAnalytics.referrerId,
      description: isVisible ? collapseAnalytics.linkName : expandAnalytics.linkName,
      callback: (referrerId, linkName) => {
        clickTracker(referrerId, linkName);
      }
    };
  }
  const onToggle = React34.useCallback(() => {
    if (isVisible) {
      setLabel(collapsedLabel);
    } else {
      setLabel(expandedLabel);
    }
    setIsVisible(!isVisible);
  }, [isVisible, collapsedLabel, expandedLabel]);
  return /* @__PURE__ */React34.createElement(EGDSExpandoListItem, {
    analytics,
    className,
    isVisible,
    expandoTitle: /* @__PURE__ */React34.createElement(EGDSHeading3, {
      tag: titleTag,
      size: titleSize
    }, label),
    expandoDescription: children,
    onToggle,
    isIndented
  });
};
ActivitiesEGDSExpandoListItem.fragment = fragment13;
ActivitiesEGDSExpandoListItem.displayName = "ActivitiesEGDSExpandoListItem";

// ../internal/src/components/egds-expando/egds-expando.tsx
import React35 from "react";
import { gql as gql43 } from "@shared-ui/apollo-client-wrapper";
var fragment14 = gql43`
  fragment EGDSExpandoFragment on EGDSExpando {
    ... on EGDSExpandoPeek {
      ...EGDSExpandoPeekFragment
    }
    ... on EGDSExpandoListItem {
      ...EGDSExpandoListItemFragment
    }
  }

  ${ActivitiesEGDSExpandoPeek.fragment}
  ${ActivitiesEGDSExpandoListItem.fragment}
`;
var ActivitiesEGDSExpando = ({
  className,
  expandoListItemTitleSize,
  expandoListItemTitleTag,
  expandoListItemIsIndented,
  expandoPeekLines,
  expandoPeekItems,
  data,
  children
}) => {
  switch (data == null ? void 0 : data.__typename) {
    case "EGDSExpandoPeek":
      return /* @__PURE__ */React35.createElement(ActivitiesEGDSExpandoPeek, {
        className,
        data,
        lines: expandoPeekLines,
        items: expandoPeekItems
      }, children);
    case "EGDSExpandoListItem":
      return /* @__PURE__ */React35.createElement(ActivitiesEGDSExpandoListItem, {
        className,
        data,
        titleSize: expandoListItemTitleSize,
        titleTag: expandoListItemTitleTag,
        isIndented: expandoListItemIsIndented
      }, children);
    default:
      return null;
  }
};
ActivitiesEGDSExpando.fragment = fragment14;
ActivitiesEGDSExpando.displayName = "ActivitiesEGDSExpando";

// ../internal/src/components/activity-reviews-comment/activity-reviews-comment.tsx
var __Fragment16 = gql44`
  fragment ActivityReviewsCommentFragment on ActivityReview {
    text
    author
    formattedActivityDate
    overallScoreMessage {
      ...EGDSTextFragment
    }
    formattedSubmissionDate
    reviewedOn
    userLocation
    expando {
      ...EGDSExpandoFragment
    }
  }

  ${ActivitiesEGDSExpando.fragment}
  ${ActivitiesEGDSText.fragment}
`;
var topMargin = {
  blockstart: "two"
};
var ReviewCommentsWrapper = React36.memo(({
  expando,
  text
}) => /* @__PURE__ */React36.createElement(React36.Fragment, null, expando ? /* @__PURE__ */React36.createElement(EGDSSpacing6, {
  margin: topMargin
}, /* @__PURE__ */React36.createElement(ActivitiesEGDSExpando, {
  expandoPeekLines: 4,
  data: expando
}, /* @__PURE__ */React36.createElement(EGDSText7, {
  overflow: "wrap",
  size: 300
}, text))) : /* @__PURE__ */React36.createElement(EGDSSpacing6, {
  margin: topMargin
}, /* @__PURE__ */React36.createElement(EGDSText7, {
  size: 300
}, text))));
ReviewCommentsWrapper.displayName = "ReviewCommentsWrapper";
var ActivityReviewsComment = ({
  className,
  headingSize,
  headingTag,
  data
}) => {
  const {
    author,
    overallScoreMessage,
    reviewedOn,
    formattedSubmissionDate,
    formattedActivityDate,
    userLocation,
    text,
    expando
  } = data;
  return /* @__PURE__ */React36.createElement("div", {
    className
  }, overallScoreMessage && /* @__PURE__ */React36.createElement(ActivitiesEGDSText, {
    data: overallScoreMessage,
    headingSize,
    headingTag
  }), author && /* @__PURE__ */React36.createElement(EGDSSpacing6, {
    margin: topMargin
  }, /* @__PURE__ */React36.createElement(EGDSHeading4, {
    tag: "h3",
    size: 6
  }, author)), reviewedOn && /* @__PURE__ */React36.createElement(EGDSText7, {
    size: 300
  }, reviewedOn), formattedSubmissionDate && /* @__PURE__ */React36.createElement(EGDSText7, {
    size: 300
  }, formattedSubmissionDate), userLocation && /* @__PURE__ */React36.createElement(EGDSText7, {
    size: 300
  }, userLocation), /* @__PURE__ */React36.createElement(ReviewCommentsWrapper, {
    expando,
    text
  }), formattedActivityDate && /* @__PURE__ */React36.createElement(EGDSSpacing6, {
    margin: topMargin
  }, /* @__PURE__ */React36.createElement(EGDSText7, {
    size: 200
  }, formattedActivityDate)));
};
ActivityReviewsComment.displayName = "ActivityReviewsCommentList";
ActivityReviewsComment.fragment = __Fragment16;

// ../internal/src/components/activity-reviews-sort-tab/activity-reviews-sort-tab.tsx
import React37 from "react";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSTab, EGDSTabs, EGDSTabsType } from "@egds/react-core/tabs";
import { EGDSHeading as EGDSHeading5 } from "@egds/react-core/text";
import { gql as gql45 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
var __Fragment17 = gql45`
  fragment ActivityReviewsSortTabFragment on ActivityTabbedNavigationBar {
    heading
    tabs {
      label
      selected
      clickAction {
        ...ActivityClickActionsFragment
      }
    }
  }

  ${__ActivityClickActionsFragment}
`;
var tabsMargin = {
  block: "two"
};
var ActivityReviewsSortTab = ({
  className,
  data,
  onClick
}) => {
  const {
    heading,
    tabs
  } = data;
  const [activeTab, setActiveTab] = React37.useState(tabs.findIndex(tab => tab.selected));
  const clickTracker = useClickTracker14();
  if (!tabs.length) {
    return null;
  }
  const handleTabChanges = tabIndex => {
    var _a;
    const selectedTab = (_a = tabs[tabIndex]) == null ? void 0 : _a.clickAction;
    const selectedAction = selectedTab ? getClickAction(selectedTab, clickTracker) : null;
    onClick(selectedAction == null ? void 0 : selectedAction.selectedTabAction);
    setActiveTab(tabIndex);
  };
  return /* @__PURE__ */React37.createElement("div", {
    className
  }, heading && /* @__PURE__ */React37.createElement(EGDSHeading5, {
    tag: "h3",
    size: 6
  }, heading), /* @__PURE__ */React37.createElement(EGDSSpacing7, {
    margin: tabsMargin
  }, /* @__PURE__ */React37.createElement(EGDSTabs, {
    onTabSelect: handleTabChanges,
    selectedTab: activeTab,
    tabsType: EGDSTabsType.NATURAL,
    role: "tablist",
    withBorder: true
  }, tabs.map(sortType => {
    var _a, _b;
    return /* @__PURE__ */React37.createElement(EGDSTab, {
      name: sortType.label,
      key: sortType.label,
      targetURI: "#",
      tabLinkAttr: {
        "aria-label": (_b = (_a = sortType.clickAction) == null ? void 0 : _a.accessibilityText) != null ? _b : ""
      }
    });
  }))));
};
ActivityReviewsSortTab.displayName = "ActivityReviewsSortTab";
ActivityReviewsSortTab.fragment = __Fragment17;

// ../internal/src/components/activity-reviews-summary/activity-reviews-summary.tsx
import React38 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { gql as gql46 } from "@shared-ui/apollo-client-wrapper";
var __Fragment18 = gql46`
  fragment ActivityReviewsSummaryFragment on ActivityReviewsSummary {
    averageScore {
      ...EGDSTextFragment
    }
    disclaimer {
      ...ActivityDisclaimerDialogFragment
    }
    sectionRef
    reviewSuperlative {
      size
      ...EGDSStylizedTextFragment
    }
  }

  ${ActivitiesEGDSText.fragment}
  ${ActivityDisclaimerDialog.fragment}
  ${EGDSStylizedText.fragment}
`;
var disclaimerMargin = {
  inlinestart: "two",
  blockstart: "one"
};
var reviewMargin = {
  blockstart: "one"
};
var ActivityReviewsSummary = ({
  className,
  data,
  dialogIdSuffix,
  headingSize,
  headingTag
}) => {
  const {
    averageScore,
    disclaimer,
    sectionRef,
    reviewSuperlative
  } = data;
  const {
    size: superlativeSize
  } = reviewSuperlative || {};
  const ActivityReviewsRating = () => /* @__PURE__ */React38.createElement("div", {
    className,
    id: sectionRef != null ? sectionRef : void 0
  }, /* @__PURE__ */React38.createElement(EGDSLayoutFlex4, null, /* @__PURE__ */React38.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React38.createElement(ActivitiesEGDSText, {
    data: averageScore,
    headingSize,
    headingTag,
    tabIndex: -1
  })), disclaimer && /* @__PURE__ */React38.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React38.createElement(EGDSSpacing8, {
    margin: disclaimerMargin
  }, /* @__PURE__ */React38.createElement(ActivityDisclaimerDialog, {
    data: disclaimer,
    dialogIdSuffix
  })))));
  const ActivityHighlightReviewsRating = () => {
    const {
      textSize: averageScoreSize
    } = averageScore;
    return /* @__PURE__ */React38.createElement("div", {
      className,
      id: sectionRef != null ? sectionRef : void 0
    }, /* @__PURE__ */React38.createElement(EGDSLayoutFlex4, {
      wrap: "wrap",
      direction: "column"
    }, /* @__PURE__ */React38.createElement(ActivitiesEGDSText, {
      data: averageScore,
      textSize: Number(averageScoreSize),
      tabIndex: -1
    }), reviewSuperlative && /* @__PURE__ */React38.createElement(EGDSSpacing8, {
      margin: reviewMargin
    }, /* @__PURE__ */React38.createElement(EGDSStylizedText, {
      data: reviewSuperlative,
      size: Number(superlativeSize)
    })), disclaimer && /* @__PURE__ */React38.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React38.createElement(EGDSSpacing8, {
      margin: reviewMargin
    }, /* @__PURE__ */React38.createElement(ActivityDisclaimerDialog, {
      data: disclaimer,
      dialogIdSuffix
    })))));
  };
  return dialogIdSuffix === "ActivityReviews" && averageScore && averageScore.__typename === "EGDSStylizedText" ? ActivityHighlightReviewsRating() : ActivityReviewsRating();
};
ActivityReviewsSummary.displayName = "ActivityReviewsSummary";
ActivityReviewsSummary.fragment = __Fragment18;

// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-more-button.tsx
import React39 from "react";
import { EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { gql as gql47 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
var __Fragment19 = gql47`
  fragment ActivityReviewsMoreButtonFragment on ActivityReviewsPaginationButton {
    action {
      ...ActivityClickActionsFragment
    }
    button {
      ...EGDSButtonFragment
    }
  }

  ${__ActivityClickActionsFragment}
  ${ActivitiesEGDSButton.fragment}
`;
var ActivityReviewsMoreButton = ({
  data,
  fetchMoreAction
}) => {
  const {
    action,
    button
  } = data;
  const tracker = useClickTracker15();
  const loadMoreReviews = React39.useCallback(() => {
    const selectedAction = getClickAction(action, tracker);
    fetchMoreAction(selectedAction == null ? void 0 : selectedAction.paginatedIndex);
  }, [fetchMoreAction]);
  return /* @__PURE__ */React39.createElement(EGDSSecondaryButton2, {
    "data-stid": "more-reviews-button",
    onClick: loadMoreReviews
  }, button.primary);
};
ActivityReviewsMoreButton.displayName = "ActivityReviewsMoreButton";
ActivityReviewsMoreButton.fragment = __Fragment19;

// ../internal/src/components/activity-reviews-dialog-content/activity-reviews-dialog-content.tsx
var __Fragment20 = gql48`
  fragment ActivityReviewsDialogContentFragment on ActivityReviewListComponent {
    comments {
      ...ActivityReviewsCommentFragment
    }
    summary {
      ...ActivityReviewsSummaryFragment
    }
    sortTabs {
      ...ActivityReviewsSortTabFragment
    }
    moreButton {
      ...ActivityReviewsMoreButtonFragment
    }
  }

  ${ActivityReviewsComment.fragment}
  ${ActivityReviewsSummary.fragment}
  ${ActivityReviewsSortTab.fragment}
  ${ActivityReviewsMoreButton.fragment}
`;
var reviewPadding = {
  small: {
    inline: "three",
    block: "twelve"
  },
  large: {
    inline: "twelve",
    block: "twelve"
  }
};
var reviewGrid = {
  large: ["1fr", "2fr"]
};
var showMorePadding = {
  blockstart: "six"
};
var ActivityReviewsDialogContent = ({
  data,
  fetchMoreAction,
  handleSortTabClick
}) => {
  const {
    summary,
    comments,
    sortTabs,
    moreButton
  } = data;
  const scrollElementRef = useRef();
  const pageParams = useQueryParams();
  const deleteParam = useDeleteParam();
  const reviewId = pageParams !== void 0 ? pageParams.get("reviewId") : null;
  React40.useEffect(() => {
    var _a;
    if (reviewId) {
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      (_a = scrollElementRef.current) == null ? void 0 : _a.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "start"
      });
      deleteParam("reviewId");
    }
  }, [reviewId]);
  if (!summary || !comments.length) {
    return null;
  }
  return /* @__PURE__ */React40.createElement(EGDSCard3, null, /* @__PURE__ */React40.createElement(EGDSSpacing9, {
    padding: reviewPadding
  }, /* @__PURE__ */React40.createElement(EGDSLayoutGrid, {
    columns: reviewGrid,
    space: "six"
  }, /* @__PURE__ */React40.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React40.createElement(ActivityReviewsSummary, {
    data: summary,
    dialogIdSuffix: "ActivityReviews",
    headingSize: 5
  })), /* @__PURE__ */React40.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React40.createElement("div", {
    key: "commentsSection"
  }, sortTabs && /* @__PURE__ */React40.createElement(ActivityReviewsSortTab, {
    key: "sortTabs",
    data: sortTabs,
    onClick: handleSortTabClick
  }), comments.map((comment, index) => /* @__PURE__ */React40.createElement("div", {
    key: index,
    ref: index === Number(reviewId) ? scrollElementRef : null
  }, /* @__PURE__ */React40.createElement(ActivityReviewsComment, {
    key: `review-comment-${index}`,
    data: comment
  }), /* @__PURE__ */React40.createElement(EGDSSpacingHr, {
    blockMargin: "six"
  }))), moreButton && /* @__PURE__ */React40.createElement(EGDSSpacing9, {
    padding: showMorePadding
  }, /* @__PURE__ */React40.createElement(EGDSLayoutFlex5, {
    justifyContent: "center"
  }, /* @__PURE__ */React40.createElement(ActivityReviewsMoreButton, {
    fetchMoreAction,
    data: moreButton
  }))))))));
};
ActivityReviewsDialogContent.displayName = "ActivityReviewsDialogContent";
ActivityReviewsDialogContent.fragment = __Fragment20;

// ../internal/src/components/activity-dialog/context/activity-reviews-context.tsx
import React41 from "react";
var ActivityReviewsContext = React41.createContext(void 0);
var useReviewsContentContext = () => {
  const context = React41.useContext(ActivityReviewsContext);
  if (!context) {
    return null;
  }
  return context;
};

// ../internal/src/components/activity-dialog/activity-review-comments-dialog.tsx
var __Fragment21 = gql49`
  fragment ActivityReviewCommentsDialogFragment on ActivityReviewCommentsDialog {
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
  }

  ${EGDSDialogToolbar.fragment}
  ${ActivityDialogTrigger.fragment}
`;
var ActivityReviewCommentsDialog = ({
  reviewsDialogContent,
  onMoreReviewsClickHandler,
  onSortTabClickHandler,
  dialogId,
  openDialogCallBackHandler,
  data: {
    dialog,
    trigger
  }
}) => {
  var _a;
  const {
    closeAnalytics,
    toolbar
  } = dialog;
  const clickTracker = useClickTracker16();
  const dialogIdentifier = `ActivityReviewCommentsDialog-${dialogId}`;
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog5(dialogIdentifier, "nestedReviewCommentsDialog");
  const ActivityReviewsContent = (_a = useReviewsContentContext()) == null ? void 0 : _a.ActivityReviewsContent;
  const triggerRef = React42.useRef(null);
  const toolbarAction = () => {
    if (closeAnalytics) {
      clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  };
  const dialogTriggerAction = () => {
    dialogActions.openDialog();
    if (openDialogCallBackHandler) {
      openDialogCallBackHandler();
    }
  };
  return /* @__PURE__ */React42.createElement(React42.Fragment, null, /* @__PURE__ */React42.createElement(EGDSLayoutFlex6, null, /* @__PURE__ */React42.createElement(ActivityDialogTrigger, {
    openDialog: dialogTriggerAction,
    data: trigger,
    domRef: triggerRef
  })), /* @__PURE__ */React42.createElement(EGDSSheetTransition5, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React42.createElement(DialogComponent, null, /* @__PURE__ */React42.createElement(EGDSSheet3, {
    type: "full",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React42.createElement(EGDSDialogToolbar, {
    data: toolbar,
    toolbarAction,
    toolbarType: "close"
  }), /* @__PURE__ */React42.createElement(EGDSDialogContent2, null, reviewsDialogContent && onMoreReviewsClickHandler && onSortTabClickHandler ? /* @__PURE__ */React42.createElement(ActivityReviewsDialogContent, {
    fetchMoreAction: onMoreReviewsClickHandler,
    handleSortTabClick: onSortTabClickHandler,
    data: reviewsDialogContent
  }) : ActivityReviewsContent && /* @__PURE__ */React42.createElement(ActivityReviewsContent, null))))));
};
ActivityReviewCommentsDialog.displayName = "ActivityReviewCommentsDialog";
ActivityReviewCommentsDialog.fragment = __Fragment21;

// ../internal/src/components/activity-dialog/activity-location-map-dialog.tsx
import React46 from "react";
import { EGDSSheet as EGDSSheet5, EGDSSheetTransition as EGDSSheetTransition7 } from "@egds/react-core/sheet";
import { gql as gql54 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";

// ../internal/src/components/activity-map/activity-map.tsx
import React45 from "react";
import { Map, MapType } from "@egds/react-maps";
import { gql as gql53 } from "@shared-ui/apollo-client-wrapper";

// ../../map/google-maps-sdk-version-provider/src/components/google-maps-sdk-version-provider/google-maps-sdk-version-provider.tsx
import React43, { createContext, useContext, useMemo as useMemo2 } from "react";
var GoogleMapsSdkVersionContext = createContext({
  version: void 0
});
var useGoogleMapsSdkVersion = () => useContext(GoogleMapsSdkVersionContext);
function GoogleMapsSdkVersionProvider({
  version,
  children
}) {
  const memoizedVersion = useMemo2(() => ({
    version
  }), [version]);
  return /* @__PURE__ */React43.createElement(GoogleMapsSdkVersionContext.Provider, {
    value: memoizedVersion
  }, children);
}
GoogleMapsSdkVersionProvider.displayName = "sharedui-GoogleMapsSdkVersionProvider";

// ../internal/src/components/activity-map/__private/utils/get-qualifiers.ts
import { MapQualifier } from "@egds/react-maps";
var egMapsIconTypeMapper = {
  hotel: MapQualifier.HOTEL,
  people: MapQualifier.PEOPLE,
  activity: MapQualifier.ACTIVITY,
  focal: MapQualifier.FOCAL
};
var getQualifiers = qualifiers => qualifiers.map(qualifier => egMapsIconTypeMapper[qualifier] || egMapsIconTypeMapper.hotel);

// ../internal/src/components/activity-map/__private/utils/get-feature-object.ts
var getFeatureObject = (marker, index) => {
  const {
    markerStatus,
    markerIconType,
    markerPosition,
    placeCard,
    markerType,
    text
  } = marker;
  const commonFields = {
    id: index,
    qualifiers: getQualifiers(markerIconType),
    lat: markerPosition.latitude,
    lng: markerPosition.longitude,
    thumbnail: placeCard == null ? void 0 : placeCard.image
  };
  switch (markerType) {
    case "property":
    // property is deprecated and will fallback to default when returned from experience layer
    case "product":
      return __spreadValues({
        type: "product",
        status: markerStatus.toLowerCase(),
        price: text
      }, commonFields);
    case "place":
      return __spreadValues({
        type: "place",
        status: "unknown",
        text
      }, commonFields);
    default:
      return __spreadValues({
        type: "place",
        status: "unknown",
        text
      }, commonFields);
  }
};

// ../internal/src/components/activity-map/__private/map-marker.ts
import { gql as gql51 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/activity-map/__private/activity-map-place-card.tsx
import React44 from "react";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3, EGDSImage as EGDSImage3 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet4, EGDSSheetTransition as EGDSSheetTransition6 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { gql as gql50 } from "@shared-ui/apollo-client-wrapper";
var fragment15 = gql50`
  fragment ActivityMapPlaceCardFragment on ActivityMapPlaceCard {
    image {
      description
      url
    }
    primary {
      ...EGDSTextFragment
    }
    secondaries {
      ...EGDSTextFragment
    }
    tag {
      ...EGDSTextFragment
    }
  }

  ${ActivitiesEGDSText.fragment}
`;
var gridColumnsWithImage = ["1fr", "3fr"];
var gridColumns = ["1fr"];
var ActivityMapPlaceCard = ({
  className,
  data
}) => {
  if (!data) {
    return null;
  }
  const {
    image,
    primary,
    secondaries,
    tag
  } = data;
  return /* @__PURE__ */React44.createElement(EGDSSheetTransition6, {
    isVisible: true
  }, /* @__PURE__ */React44.createElement(EGDSSheet4, {
    className,
    isVisible: true,
    triggerRef: null
  }, /* @__PURE__ */React44.createElement(EGDSLayoutGrid2, {
    columns: image ? gridColumnsWithImage : gridColumns
  }, image && /* @__PURE__ */React44.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React44.createElement(EGDSFigure3, {
    ratio: EGDSFigureAspectRatioType3.R16_9
  }, /* @__PURE__ */React44.createElement(EGDSImage3, {
    alt: image.description,
    src: image.url,
    placeholderImage: true
  }))), /* @__PURE__ */React44.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React44.createElement(EGDSSpacing10, {
    padding: "three"
  }, /* @__PURE__ */React44.createElement(EGDSLayoutFlex7, {
    direction: "column",
    space: "one"
  }, tag && /* @__PURE__ */React44.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React44.createElement(ActivitiesEGDSText, {
    data: tag
  })), primary && /* @__PURE__ */React44.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React44.createElement(ActivitiesEGDSText, {
    data: primary
  })), secondaries == null ? void 0 : secondaries.map((secondary, key) => /* @__PURE__ */React44.createElement(EGDSLayoutFlexItem5, {
    key: `map-place-card-secondaries${key}`
  }, /* @__PURE__ */React44.createElement(ActivitiesEGDSText, {
    data: secondary
  })))))))));
};
ActivityMapPlaceCard.fragment = fragment15;
ActivityMapPlaceCard.displayName = "ActivityMapPlaceCard";

// ../internal/src/components/activity-map/__private/map-marker.ts
var __MapMarkersFragment = gql51`
  fragment MapMarkersFragment on ActivityMapMarker {
    markerType
    markerIconType
    markerStatus
    markerPosition {
      latitude
      longitude
    }
    text
    placeCard {
      ...ActivityMapPlaceCardFragment
    }
  }

  ${ActivityMapPlaceCard.fragment}
`;

// ../internal/src/components/activity-map/egds-dynamic-map-config.ts
import { gql as gql52 } from "@shared-ui/apollo-client-wrapper";
var __EGDSDynamicMapConfigFragment = gql52`
  fragment EGDSDynamicMapConfigFragment on EGDSDynamicMapConfig {
    accessToken
    egdsMapProvider
  }
`;

// ../internal/src/components/activity-map/activity-map.tsx
var fragment16 = gql53`
  fragment ActivityMapFragment on ActivityMap {
    __typename
    egMap {
      center {
        latitude
        longitude
      }
      config {
        ...EGDSDynamicMapConfigFragment
      }
    }
    markers {
      ...MapMarkersFragment
    }
  }

  ${__EGDSDynamicMapConfigFragment}
  ${__MapMarkersFragment}
`;
var ActivityMap = ({
  data,
  dynamicMapSize
}) => {
  var _a;
  const {
    egMap,
    markers
  } = data;
  const {
    config
  } = egMap;
  const [, setSelectedMarker] = React45.useState(null);
  const [placeCard, setPlaceCard] = React45.useState(null);
  const accessToken = config.__typename === "EGDSDynamicMapConfig" ? config.accessToken : "";
  const mapFeatures = markers.map((marker, index) => getFeatureObject(marker, index));
  const coordinates = mapFeatures.filter(f => f.lat !== void 0 && f.lng !== void 0).map(feature => ({
    lat: feature.lat || 0,
    lng: feature.lng || 0
  }));
  const onMarkerSelectionChanged = React45.useCallback(event => {
    var _a2;
    const {
      action,
      feature
    } = event;
    switch (action) {
      case "clearSelection":
        setSelectedMarker(null);
        setPlaceCard(null);
        break;
      case "select":
        setSelectedMarker(feature);
        setPlaceCard((_a2 = markers[feature.id]) == null ? void 0 : _a2.placeCard);
        break;
      default:
        break;
    }
  }, [markers]);
  const beforeInit = React45.useCallback(map => {
    map.addSelectionChangeListener(onMarkerSelectionChanged, "selectionChanged");
  }, [onMarkerSelectionChanged]);
  const initialViewport = {
    useBoundsComputation: true,
    coordinates: coordinates.length > 0 ? coordinates : void 0
  };
  const mapConfig = React45.useMemo(() => ({
    markers: {
      product: {
        markerType: {
          available: "pin"
        }
      }
    }
  }), []);
  const googleMapsSdkVersion = (_a = useGoogleMapsSdkVersion()) == null ? void 0 : _a.version;
  return /* @__PURE__ */React45.createElement(Map, {
    accessToken,
    mapType: MapType.GOOGLE,
    mapTypeVersion: googleMapsSdkVersion,
    features: mapFeatures,
    height: dynamicMapSize,
    initialViewport,
    beforeInit,
    mapConfig
  }, placeCard && /* @__PURE__ */React45.createElement(ActivityMapPlaceCard, {
    data: placeCard
  }));
};
ActivityMap.fragment = fragment16;
ActivityMap.displayName = "ActivityMap";

// ../internal/src/components/activity-dialog/activity-location-map-dialog.tsx
var __Fragment22 = gql54`
  fragment ActivityLocationMapDialogFragment on ActivityLocationMapDialog {
    dialog {
      closeAnalytics {
        linkName
        referrerId
      }
      toolbar {
        ...EGDSDialogToolbarFragment
      }
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
    dynamicMap {
      ...ActivityMapFragment
    }
  }

  ${EGDSDialogToolbar.fragment}

  ${ActivityMap.fragment}
  ${ActivityDialogTrigger.fragment}
`;
var ActivityLocationMapDialog = ({
  data: {
    dialog,
    trigger,
    dynamicMap
  }
}) => {
  const {
    closeAnalytics,
    toolbar
  } = dialog;
  const clickTracker = useClickTracker17();
  const dialogKey = React46.useMemo(() => Math.random().toString(36).slice(2, 5), []);
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog6(`activity-map-${dialogKey}`, "nestedActivityMapDialog");
  const triggerRef = React46.useRef(null);
  const toolbarAction = () => {
    if (closeAnalytics) {
      clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
    }
    dialogActions.closeDialog();
  };
  return /* @__PURE__ */React46.createElement(React46.Fragment, null, /* @__PURE__ */React46.createElement(ActivityDialogTrigger, {
    openDialog: dialogActions.openDialog,
    data: trigger,
    domRef: triggerRef
  }), /* @__PURE__ */React46.createElement(EGDSSheetTransition7, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React46.createElement(DialogComponent, null, /* @__PURE__ */React46.createElement(EGDSSheet5, {
    type: "full",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React46.createElement(EGDSDialogToolbar, {
    data: toolbar,
    toolbarAction,
    toolbarType: "close"
  }), /* @__PURE__ */React46.createElement(ActivityMap, {
    data: dynamicMap
  })))));
};
ActivityLocationMapDialog.displayName = "ActivityLocationMapDialog";
ActivityLocationMapDialog.fragment = __Fragment22;

// ../internal/src/components/activity-dialog/sign-in-dialog/sign-in-egds-action-dialog.tsx
import React47 from "react";
import { EGDSDialog as EGDSDialog2, EGDSDialogContent as EGDSDialogContent3, EGDSDialogFooter as EGDSDialogFooter2 } from "@egds/react-core/dialog";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSHeading as EGDSHeading6, EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
import { gql as gql55 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
var fragment17 = gql55`
  fragment SignInActivityActionDialogFragment on EGDSActionDialog {
    closeAnalytics {
      referrerId
      linkName
    }
    footer {
      ... on EGDSStackedDialogFooter {
        buttons {
          ... on EGDSOverlayButton {
            __typename
          }
        }
      }
      ... on EGDSInlineDialogFooter {
        buttons {
          ... on UIPrimaryButton {
            accessibility
            primary
            disabled
            action {
              ... on UILinkAction {
                resource {
                  value
                }
                analytics {
                  linkName
                  referrerId
                }
              }
            }
          }
          ... on UITertiaryButton {
            accessibility
            primary
            action {
              ... on UILinkAction {
                resource {
                  value
                }
              }
            }
            disabled
          }
        }
      }
    }
  }
`;
var SignInActivityActionDialog = ({
  data,
  actionsCallback,
  closeDialog,
  content,
  title,
  graphic
}) => {
  const clickstreamAnalytics = useClickTracker18();
  const {
    footer: {
      buttons
    }
  } = data;
  const triggerRef = React47.createRef();
  const handleCloseButtonClick = () => {
    closeDialog();
  };
  const handleActionButtonClick = (url, analytics) => {
    window.location.replace(url);
    clickstreamAnalytics(analytics.referrerId, analytics.linkName);
  };
  const [buttonOne, buttonTwo, buttonThree] = buttons.map(currentButton => {
    if (currentButton.__typename === "UIPrimaryButton") {
      const {
        primary: primary2
      } = currentButton;
      const primarybtn = {
        text: primary2,
        type: "primary",
        onClick: () => {
          var _a;
          return ((_a = currentButton.action) == null ? void 0 : _a.__typename) === "UILinkAction" ? handleActionButtonClick(currentButton.action.resource.value, currentButton.action.analytics) : handleCloseButtonClick();
        }
      };
      return primarybtn;
    }
    const {
      primary
    } = currentButton;
    return {
      text: primary,
      type: "tertiary",
      onClick: () => handleCloseButtonClick()
    };
  });
  return /* @__PURE__ */React47.createElement(EGDSDialog2, {
    dialogShow: true,
    returnFocusOnClose: true
  }, /* @__PURE__ */React47.createElement(EGDSDialogContent3, null, /* @__PURE__ */React47.createElement(EGDSLayoutGrid3, {
    columns: ["0.8fr", "8fr"],
    space: "one",
    justifyContent: "start"
  }, /* @__PURE__ */React47.createElement(EGDSLayoutGridItem3, {
    justifySelf: "start"
  }, /* @__PURE__ */React47.createElement("div", null, graphic && /* @__PURE__ */React47.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React47.createElement(EGDSLayoutGridItem3, {
    justifySelf: "start"
  }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(EGDSHeading6, {
    size: 5
  }, title), /* @__PURE__ */React47.createElement(EGDSParagraph2, {
    key: "dialogParagraph",
    size: 2
  }, content)))), /* @__PURE__ */React47.createElement(EGDSDialogFooter2, {
    stacked: false,
    buttonOne,
    buttonTwo
  })));
};
SignInActivityActionDialog.fragment = fragment17;
SignInActivityActionDialog.displayName = "SignInActivityActionDialog";

// ../internal/src/components/activity-dialog/sign-in-dialog/sign-in-egds-dialog.tsx
import React48 from "react";
import { EGDSSheetTransition as EGDSSheetTransition8 } from "@egds/react-core/sheet";
import { gql as gql56 } from "@shared-ui/apollo-client-wrapper";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
var fragment18 = gql56`
  fragment SignInActivityDialogFragment on EGDSDialog {
    ...SignInActivityActionDialogFragment
  }
  ${SignInActivityActionDialog.fragment}
`;
var SignInActivityDialog = ({
  data,
  title,
  dialogId,
  dialogContent,
  handleActionsCallback,
  graphic
}) => {
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog7(dialogId);
  const closeDialog = () => {
    dialogActions.closeDialog();
  };
  if (!dialogContent) {
    return null;
  }
  return /* @__PURE__ */React48.createElement("div", {
    "data-stid": dialogId
  }, /* @__PURE__ */React48.createElement(EGDSSheetTransition8, {
    isVisible: true
  }, /* @__PURE__ */React48.createElement(DialogComponent, null, /* @__PURE__ */React48.createElement(SignInActivityActionDialog, {
    data,
    content: dialogContent,
    closeDialog,
    title,
    actionsCallback: handleActionsCallback,
    graphic
  }))));
};
SignInActivityDialog.fragment = fragment18;
SignInActivityDialog.displayName = "SignInActivityDialog";

// ../internal/src/components/egds-basic-thumbnail-media-gallery/egds-basic-thumbnail-media-gallery.tsx
import React49 from "react";
import { EGDSCard as EGDSCard4 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4, MinMax, Repeat } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet6, EGDSSheetContent as EGDSSheetContent3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSToolbar as EGDSToolbar2 } from "@egds/react-core/toolbar";
import { gql as gql57 } from "@shared-ui/apollo-client-wrapper";
var __Fragment23 = gql57`
  fragment EGDSBasicThumbnailMediaGalleryFragment on EGDSBasicThumbnailMediaGallery {
    tabs {
      selectedTabId
    }
    thumbnails {
      ...ActivityMediaItemFragment
    }
    toolbar {
      ...EGDSDialogToolbarFragment
    }
  }

  ${EGDSDialogToolbar.fragment}
  ${ActivityMediaItem.fragment}
`;
var EGDSBasicThumbnailMediaGallery = ({
  className,
  onImageClick,
  data,
  columns,
  dialogType,
  onDialogDismiss,
  triggerRef
}) => {
  var _a, _b;
  const {
    thumbnails,
    toolbar
  } = data;
  const defaultColumns = {
    large: [Repeat(2, MinMax("72x", "1fr"))],
    medium: [Repeat(2, MinMax("48x", "1fr"))],
    small: [Repeat(1, MinMax("48x", "1fr"))]
  };
  const handleImageSelected = React49.useCallback(index => {
    onImageClick == null ? void 0 : onImageClick(index);
  }, [onImageClick]);
  const thumbnailView = /* @__PURE__ */React49.createElement(EGDSCard4, {
    padded: true
  }, /* @__PURE__ */React49.createElement(EGDSLayoutGrid4, {
    tag: "ul",
    columns: columns != null ? columns : defaultColumns,
    space: "two"
  }, thumbnails.map((card, index) => {
    switch (card.__typename) {
      case "ActivityMediaItem":
        return /* @__PURE__ */React49.createElement(EGDSLayoutGridItem4, {
          key: index
        }, /* @__PURE__ */React49.createElement(ActivityMediaItem, {
          data: card,
          index,
          onClick: handleImageSelected,
          className,
          isThumbnailVisible: true
        }));
      default:
        return null;
    }
  })));
  return /* @__PURE__ */React49.createElement(EGDSSheet6, {
    isVisible: true,
    triggerRef: triggerRef != null ? triggerRef : null,
    type: dialogType != null ? dialogType : "centered",
    className
  }, /* @__PURE__ */React49.createElement(EGDSToolbar2, {
    navigationContent: {
      onClick: onDialogDismiss,
      navIconLabel: (_a = toolbar.closeText) != null ? _a : void 0
    },
    toolbarTitle: (_b = toolbar.title) != null ? _b : void 0
  }), /* @__PURE__ */React49.createElement(EGDSSheetContent3, {
    fullSheetContentMaxWidth: "extra-large",
    padded: false
  }, /* @__PURE__ */React49.createElement(EGDSSpacing11, {
    padding: "twelve"
  }, thumbnailView)));
};
EGDSBasicThumbnailMediaGallery.displayName = "EGDSBasicThumbnailMediaGallery";
EGDSBasicThumbnailMediaGallery.fragment = __Fragment23;

// src/components/image-gallery/__private/__fragments/activity-thumbnail-media-gallery-dialog.tsx
import { gql as gql58 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
var __Fragment24 = gql58`
  fragment ActivityThumbnailMediaGalleryDialogFragment on ActivityThumbnailMediaGalleryDialog {
    dialog {
      ...EGDSBasicThumbnailMediaGalleryFragment
    }
    trigger {
      ...ActivityDialogTriggerFragment
    }
  }

  ${EGDSBasicThumbnailMediaGallery.fragment}
  ${ActivityDialogTrigger.fragment}
`;
var ActivityThumbnailMediaGalleryDialog = ({
  className,
  data,
  openCarousel
}) => {
  const [, thumbnailGalleryDialogActions, ThumbnailGalleryDialogWrapper] = useDialog8("thumbnail-gallery", "nested-thumbnail-gallery");
  const triggerRef = React50.useRef(null);
  const columns = {
    large: [Repeat2(2, MinMax2("120x", "1fr"))],
    medium: [Repeat2(2, MinMax2("88x", "1fr"))],
    small: [Repeat2(1, MinMax2("88x", "1fr"))]
  };
  const trackClick = useClickTracker19();
  const openThumbnailGalleryDialog = React50.useCallback(() => {
    triggerRef.current = document.activeElement;
    thumbnailGalleryDialogActions.openDialog();
    trackClick(data.trigger.analytics.referrerId, data.trigger.analytics.linkName);
  }, [thumbnailGalleryDialogActions]);
  return /* @__PURE__ */React50.createElement(React50.Fragment, null, /* @__PURE__ */React50.createElement(ActivityDialogTrigger, {
    openDialog: openThumbnailGalleryDialog,
    data: data.trigger
  }), /* @__PURE__ */React50.createElement(ThumbnailGalleryDialogWrapper, null, /* @__PURE__ */React50.createElement(EGDSBasicThumbnailMediaGallery, {
    className,
    onImageClick: openCarousel,
    data: data.dialog,
    onDialogDismiss: thumbnailGalleryDialogActions.closeDialog,
    dialogType: "full",
    columns,
    triggerRef
  })));
};
ActivityThumbnailMediaGalleryDialog.fragment = __Fragment24;
ActivityThumbnailMediaGalleryDialog.displayName = "ActivityThumbnailMediaGalleryDialog";

// src/components/image-gallery/image-gallery.tsx
var __Query = gql59`
  query ImageGalleryQuery($context: ContextInput!, $activityId: String!, $dateRange: ActivityDateRangeInput) {
    activityInfo(context: $context, activityId: $activityId, dateRange: $dateRange) {
      imageGallery {
        carousel {
          ...EGDSCarouselFragment
        }
        featuredMedia {
          ...ActivityMediaItemFragment
        }
        thumbnailDialog {
          ...ActivityThumbnailMediaGalleryDialogFragment
        }
      }
    }
  }

  ${ActivityMediaItem.fragment}
  ${ActivitiesEGDSCarousel.fragment}
  ${ActivityThumbnailMediaGalleryDialog.fragment}
`;
var ImageGallery = ({
  inputs,
  skipSsr
}) => {
  var _a, _b, _c;
  const {
    context
  } = useBexApi();
  const variables = __spreadProps(__spreadValues({}, inputs), {
    context
  });
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr: !skipSsr
  });
  const [isMediaCarouselDialogOpen, mediaCarouselDialogActions, MediaCarouselDialogWrapper] = useDialog9("media-carousel", "nested-media-carousel");
  const [imageIndex, setImageIndex] = React51.useState(0);
  const dialogTriggerRef = React51.useRef(null);
  const onImageClick = React51.useCallback(index => {
    setImageIndex(index);
    mediaCarouselDialogActions.openDialog();
  }, [setImageIndex, mediaCarouselDialogActions]);
  const closeCarouselDialog = React51.useCallback(() => {
    var _a2;
    mediaCarouselDialogActions.closeDialog();
    (_a2 = dialogTriggerRef.current) == null ? void 0 : _a2.focus();
  }, [mediaCarouselDialogActions]);
  const thumbnailDialog = (_a = data == null ? void 0 : data.activityInfo.imageGallery) == null ? void 0 : _a.thumbnailDialog;
  const featuredMedia = (_b = data == null ? void 0 : data.activityInfo.imageGallery) == null ? void 0 : _b.featuredMedia;
  const carousel = (_c = data == null ? void 0 : data.activityInfo.imageGallery) == null ? void 0 : _c.carousel;
  const maxImagesOnLargeView = 5;
  const maxImagesOnMediumView = 3;
  const maxImagesOnSmallView = 1;
  if (loading || error || !data) {
    return null;
  }
  if (!(carousel == null ? void 0 : carousel.items) || !thumbnailDialog || !featuredMedia) {
    return /* @__PURE__ */React51.createElement(EGDSFigure4, null, /* @__PURE__ */React51.createElement(EGDSImage4, {
      placeholderImage: true
    }));
  }
  const imageDescriptions = carousel == null ? void 0 : carousel.items.map(item => {
    if (item.__typename === "EGDSMediaCarouselItem") {
      if (item.media.__typename === "ActivityMediaItem") {
        const mediaItem = item.media.media;
        if (mediaItem.__typename === "Image" || mediaItem.__typename === "Video") {
          return mediaItem.description;
        }
      }
      return null;
    }
    return null;
  });
  return /* @__PURE__ */React51.createElement(EGDSCard5, null, /* @__PURE__ */React51.createElement(Viewport2, null, /* @__PURE__ */React51.createElement(ViewLarge, null, /* @__PURE__ */React51.createElement(EGDSLayoutPosition2, {
    type: "relative"
  }, /* @__PURE__ */React51.createElement(EGDSLayoutGrid5, {
    columns: numberOfColumns(numberOfImagesToShow(maxImagesOnLargeView, featuredMedia)),
    rows: 2,
    space: "half"
  }, featuredMedia.slice(0, numberOfImagesToShow(5, featuredMedia)).map((img, index) => /* @__PURE__ */React51.createElement(EGDSLayoutGridItem5, {
    key: `mosaic-image-${index}`,
    colSpan: index === 0 ? 2 : 1,
    rowSpan: index === 0 ? 2 : 1
  }, /* @__PURE__ */React51.createElement("div", null, /* @__PURE__ */React51.createElement(ActivityMediaItem, {
    dialogTriggerRef,
    data: img,
    onClick: onImageClick,
    index
  })))), /* @__PURE__ */React51.createElement(EGDSLayoutPosition2, {
    position: {
      zindex: "layer2",
      bottom: "three",
      right: "three"
    },
    type: "absolute"
  }, /* @__PURE__ */React51.createElement(ActivityThumbnailMediaGalleryDialog, {
    data: thumbnailDialog,
    openCarousel: onImageClick
  }))))), /* @__PURE__ */React51.createElement(ViewMedium2, null, /* @__PURE__ */React51.createElement(EGDSLayoutPosition2, {
    type: "relative"
  }, /* @__PURE__ */React51.createElement(EGDSLayoutGrid5, {
    columns: numberOfColumns(numberOfImagesToShow(maxImagesOnMediumView, featuredMedia)),
    rows: 2,
    space: "half"
  }, featuredMedia.slice(0, numberOfImagesToShow(3, featuredMedia)).map((img, index) => /* @__PURE__ */React51.createElement(EGDSLayoutGridItem5, {
    key: `mosaic-image-${index}`,
    colSpan: index === 0 ? 2 : 1,
    rowSpan: index === 0 ? 2 : 1
  }, /* @__PURE__ */React51.createElement("div", null, /* @__PURE__ */React51.createElement(ActivityMediaItem, {
    dialogTriggerRef,
    data: img,
    onClick: onImageClick,
    index
  })))), /* @__PURE__ */React51.createElement(EGDSLayoutPosition2, {
    position: {
      zindex: "layer2",
      bottom: "three",
      right: "three"
    },
    type: "absolute"
  }, /* @__PURE__ */React51.createElement(ActivityThumbnailMediaGalleryDialog, {
    data: thumbnailDialog,
    openCarousel: onImageClick
  }))))), /* @__PURE__ */React51.createElement(ViewSmall2, null, /* @__PURE__ */React51.createElement(EGDSLayoutPosition2, {
    type: "relative"
  }, /* @__PURE__ */React51.createElement(EGDSLayoutGrid5, {
    columns: numberOfColumns(numberOfImagesToShow(maxImagesOnSmallView, featuredMedia)),
    rows: 2,
    space: "half"
  }, featuredMedia.slice(0, numberOfImagesToShow(1, featuredMedia)).map((img, index) => /* @__PURE__ */React51.createElement(EGDSLayoutGridItem5, {
    key: `mosaic-image-${index}`,
    colSpan: index === 0 ? 2 : 1,
    rowSpan: index === 0 ? 2 : 1
  }, /* @__PURE__ */React51.createElement("div", null, /* @__PURE__ */React51.createElement(ActivityMediaItem, {
    dialogTriggerRef,
    data: img,
    onClick: onImageClick,
    index
  })))), /* @__PURE__ */React51.createElement(EGDSLayoutPosition2, {
    position: {
      zindex: "layer2",
      bottom: "three",
      right: "three"
    },
    type: "absolute"
  }, /* @__PURE__ */React51.createElement(ActivityThumbnailMediaGalleryDialog, {
    data: thumbnailDialog,
    openCarousel: onImageClick
  })))))), /* @__PURE__ */React51.createElement(EGDSSheetTransition9, {
    isVisible: isMediaCarouselDialogOpen
  }, /* @__PURE__ */React51.createElement(MediaCarouselDialogWrapper, null, /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React51.createElement(EGDSSheet7, {
    isVisible: isMediaCarouselDialogOpen,
    triggerRef: null,
    type: "full",
    theme: "dark"
  }, /* @__PURE__ */React51.createElement(EGDSTransparentToolbar, {
    overlay: true,
    navigationContent: {
      onClick: closeCarouselDialog,
      navIconLabel: "close dialog"
      // TODO: this should be coming from bex-api-lxshop
    }
  }), /* @__PURE__ */React51.createElement(ActivitiesEGDSCarousel, {
    data: carousel,
    currentIndex: imageIndex,
    setCurrentState: setImageIndex,
    fullSheetVisible: isMediaCarouselDialogOpen
  }), /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React51.createElement(EGDSLayoutFlex8, {
    justifyContent: "space-between",
    alignItems: "end"
  }, /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem6, null, imageDescriptions && /* @__PURE__ */React51.createElement(EGDSSpacing12, {
    margin: "one",
    padding: "two"
  }, /* @__PURE__ */React51.createElement(EGDSText8, {
    theme: "inverse"
  }, `${imageDescriptions[imageIndex]}`))), /* @__PURE__ */React51.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React51.createElement(EGDSSpacing12, {
    margin: "one",
    padding: "two"
  }, /* @__PURE__ */React51.createElement(EGDSText8, {
    theme: "inverse"
  }, `${imageIndex + 1}/${carousel.items.length}`))))))))));
};
ImageGallery.displayName = "sharedui-ImageGallery";
export { ImageGallery };